// import React, { useEffect, useState } from "react";
// import axios from 'axios';
// import {
//     Document,
//     Page,
//     Text,
//     View,
//     Image,
//     StyleSheet,
//     Font,
// } from "@react-pdf/renderer";


// const styles = StyleSheet.create({
//     frontPage: {
//         backgroundColor: '#e5e6e8',
//         position: 'relative',
//     },
//     frontPageImageContainer: {
//         width: '75%',
//         height: '45%',
//         position: 'absolute',
//         top: '-5%',
//         right: '-10%',
//         transform: 'rotate(-45deg)',
//         border: '5px solid white',
//     },
//     frontPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//         position: 'absolute',
//         top: '0%',
//         left: '0%',
//     },
//     frontPageLogoContainer: {
//         width: '20%',
//         height: '14%',
//         position: 'absolute',
//         top: '10.5%',
//         left: '10%',
//         transform: 'rotate(45deg)',
//         backgroundColor: '#bd212f',
//         // backgroundColor: '#3d2b17',
//         justifyContent: 'center', // Center the content
//         alignItems: 'center', // Center the content

//     },
//     frontPageLogoImage: {
//         width: '80%',
//         height: 'auto',
//         resizeMode: 'contain',
//         transform: 'rotate(-45deg)',

//         // height: '7.5%',
//         // position: 'relative',
//         // top: '13.7%',
//         // left: '14.3%',
//         // objectFit: 'cover',
//     },
//     frontPageBottomBox: {
//         width: '130%',
//         height: '100%',
//         position: 'absolute',
//         bottom: '-40%',
//         left: '-41.5%',
//         transform: 'rotate(45deg)',
//         backgroundColor: '#bd212f',
//         // backgroundColor: '#3d2b17',
//         border: '5px solid white',
//     },
//     frontPageHeadingContainer: {
//         position: 'absolute',
//         top: '55%',
//         left: '10%',
//         width: "70%",
//         color: 'white',
//     },
//     frontPageHeading: {
//         fontSize: 50,
//         fontWeight: '1000',
//         marginTop: 15,
//     },
//     frontPageSubheading: {
//         fontSize: 25,
//         fontWeight: 'bold',
//     },
//     frontPageDescription: {
//         fontSize: 15,
//         marginTop: 40,
//     },
//     frontPageYearContainer: {
//         position: 'absolute',
//         bottom: '5%',
//         right: '5%',
//         color: 'white',
//         fontSize: 15,
//     },
//     // For tableofcontent page ==>>
//     page: {
//         // backgroundColor: '#e5e6e8',
//         // position: 'relative',
//     },
//     tableofcontentPage: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-around',
//         alignItems: 'center',
//         height: '100%',
//     },
//     tableofcontentPageFirstContainer: {
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     tableofcontentPageHeading: {
//         fontSize: 40,
//         fontWeight: '1000',
//     },
//     tableofcontentPageSubheading: {
//         fontSize: 25,
//         fontWeight: 'bold',
//         color: '#bd212f',
//     },
//     tableofcontentPageDescription: {
//         fontSize: 20,
//     },
//     tableofcontentPageSecondContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     tableofcontentPageThirdContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     tableofcontentPageFourthContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     tableofcontentPageProductDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-evenly',
//         alignItems: 'center',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         // paddingRight: '5%',
//     },
//     tableofcontentPageProductDetails: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'stretch',
//         width: '80%',
//         height: '100%',

//     },
//     tableofcontentPageProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//         color: '#bd212f',

//     },
//     tableofcontentPageProductDescription: {
//         fontSize: 10,

//     },
//     tableofcontentPageProductPrice: {
//         fontSize: 12.5,
//         color: '#bd212f',


//     },
//     tableofcontentPageImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     tableofcontentPageImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },
//     tableofcontentVerticalLine: {
//         width: 1,
//         height: '80%',
//         backgroundColor: 'grey',
//     },

//     // For third page ==>>

//     thirdPage: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-around',
//         alignItems: 'center',
//         height: '100%',
//     },
//     thirdPageFirstContainer: {
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     thirdPageHeading: {
//         fontSize: 40,
//         fontWeight: '1000',
//         color: '#bd212f',
//     },
//     thirdPageSubheading: {
//         fontSize: 25,
//         fontWeight: 'bold',
//     },
//     thirdPageDescription: {
//         fontSize: 20,
//     },
//     thirdPageSecondContainer: {
//         backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     thirdPageThirdContainer: {
//         backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     thirdPageFourthContainer: {
//         backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     thirdPageProductDetailsContainer: {
//         color: 'white',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//     },
//     thirdPageProductTitle: {

//         fontSize: 15,
//         fontWeight: 'extrabold',
//     },
//     thirdPageProductDescription: {
//         fontSize: 10,

//     },
//     thirdPageProductPrice: {
//         fontSize: 12.5,

//     },
//     thirdPageImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     thirdPageImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },

//     // For fourth page ==>>

//     fourthPage: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-around',
//         alignItems: 'center',
//         height: '100%',
//     },
//     fourthPageFirstContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     fourthPageSecondContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     fourthPageThirdContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     fourthPageFourthContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     fourthPageProductDetailsContainer: {
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//     },
//     fourthPageProductTitle: {

//         fontSize: 15,
//         fontWeight: 'extrabold',
//         color: '#bd212f',

//     },
//     fourthPageProductDescription: {
//         fontSize: 10,

//     },
//     fourthPageProductPrice: {
//         fontSize: 12.5,
//         color: '#bd212f',


//     },
//     fourthPageImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     fourthPageImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },

//     // For fifth page ==>>

//     fifthPage: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         height: '100%',
//     },
//     fifthPageFirstContainer: {
//         width: '100%',
//         height: '40%',
//         padding: '10%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start',
//     },
//     fifthPageFirstUpperContainer: {
//         height: '20%',
//         width: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//     },
//     fifthPageSubheading: {
//         fontSize: 20,
//         fontWeight: 'bold',
//         color: '#bd212f',

//     },
//     fifthPageHeading: {
//         fontSize: 30,
//         fontWeight: '1000',
//         marginTop: 10,
//     },
//     fifthPageFirstLowerContainer: {
//         backgroundColor: '#bd212f',
//         height: '60%',
//         width: '100%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     fifthPageFirstLowerContainerProductDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'flex-start',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//         color: 'white',
//     },

//     fifthPageFirstLowerContainerProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//         textAlign: 'left',
//     },
//     fifthPageFirstLowerContainerProductDescription: {
//         fontSize: 10,
//         textAlign: 'left',

//     },
//     fifthPageFirstLowerContainerProductPrice: {
//         fontSize: 12.5,
//         // color: '#bd212f',
//         textAlign: 'left',

//     },
//     fifthPageImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     fifthPageImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },
//     fifthPageSecondContainer: {
//         width: '100%',
//         height: '60%',
//         padding: '10%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         backgroundColor: '#bd212f',
//         color: 'white',
//     },
//     fifthPageSecondLeftContainer: {
//         width: '39%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     fifthPageSecondLeftContainerProductDetailsContainer: {
//         width: '100%',
//         height: '50%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'flex-start',
//     },
//     fifthPageSecondLeftContainerProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//     },
//     fifthPageSecondLeftContainerProductDescription: {
//         fontSize: 10,
//     },
//     fifthPageSecondLeftContainerProductPrice: {
//         fontSize: 12.5,
//     },
//     fifthPageSecondLeftContainerImageContainer: {
//         width: '100%',
//         height: '40%',
//     },
//     fifthPageSecondLeftContainerImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },
//     fifthPageVerticalLine: {
//         width: 1,
//         height: '100%',
//         backgroundColor: 'white',
//     },
//     fifthPageSecondRightContainer: {
//         width: '39%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     fifthPageSecondRightContainerProductDetailsContainer: {
//         width: '100%',
//         height: '50%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'flex-start',
//     },
//     fifthPageSecondRightContainerProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//     },
//     fifthPageSecondRightContainerProductDescription: {
//         fontSize: 10,
//     },
//     fifthPageSecondRightContainerProductPrice: {
//         fontSize: 12.5,
//     },
//     fifthPageSecondRightContainerImageContainer: {
//         width: '100%',
//         height: '40%',
//     },
//     fifthPageSecondRightContainerImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },

//     // For sixth page ==>>

//     sixthPage: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         height: '100%',
//     },
//     sixthPageFirstContainer: {
//         width: '100%',
//         height: '40%',
//         padding: '10%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start',
//     },
//     sixthPageFirstUpperContainer: {
//         height: '20%',
//         width: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//     },
//     sixthPageSubheading: {
//         fontSize: 20,
//         fontWeight: 'bold',
//         color: '#bd212f',

//     },
//     sixthPageHeading: {
//         fontSize: 30,
//         fontWeight: '1000',
//         marginTop: 10,
//     },
//     sixthPageFirstLowerContainer: {
//         backgroundColor: '#bd212f',
//         height: '60%',
//         width: '100%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     sixthPageFirstLowerContainerProductDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'flex-start',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//         color: 'white',
//     },

//     sixthPageFirstLowerContainerProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//         textAlign: 'left',
//     },
//     sixthPageFirstLowerContainerProductDescription: {
//         fontSize: 10,
//         textAlign: 'left',

//     },
//     sixthPageFirstLowerContainerProductPrice: {
//         fontSize: 12.5,
//         // color: '#bd212f',
//         textAlign: 'left',

//     },
//     sixthPageImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     sixthPageImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },
//     sixthPageSecondContainer: {
//         width: '100%',
//         height: '60%',
//         padding: '10%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         backgroundColor: '#bd212f',
//         color: 'white',
//     },
//     sixthPageSecondLeftContainer: {
//         width: '39%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     sixthPageSecondLeftContainerProductDetailsContainer: {
//         width: '100%',
//         height: '50%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'flex-start',
//     },
//     sixthPageSecondLeftContainerProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//     },
//     sixthPageSecondLeftContainerProductDescription: {
//         fontSize: 10,
//     },
//     sixthPageSecondLeftContainerProductPrice: {
//         fontSize: 12.5,
//     },
//     sixthPageSecondLeftContainerImageContainer: {
//         width: '100%',
//         height: '40%',
//     },
//     sixthPageSecondLeftContainerImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },
//     sixthPageVerticalLine: {
//         width: 1,
//         height: '100%',
//         backgroundColor: 'white',
//     },
//     sixthPageSecondRightContainer: {
//         width: '39%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     sixthPageSecondRightContainerProductDetailsContainer: {
//         width: '100%',
//         height: '50%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'flex-start',
//     },
//     sixthPageSecondRightContainerProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//     },
//     sixthPageSecondRightContainerProductDescription: {
//         fontSize: 10,
//     },
//     sixthPageSecondRightContainerProductPrice: {
//         fontSize: 12.5,
//     },
//     sixthPageSecondRightContainerImageContainer: {
//         width: '100%',
//         height: '40%',
//     },
//     sixthPageSecondRightContainerImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },

//     // For seventh page ==>>

//     seventhPage: {
//         position: 'relative',
//     },
//     seventhPageBorderContainer: {
//         margin: '5% 0% 5% 5%',
//         padding: '5%',
//         borderTop: '20px solid #bd212f',
//         borderLeft: '20px solid #bd212f',
//         borderBottom: '20px solid #bd212f',
//         height: "95%"
//     },
//     seventhPageFirstContainer: {
//         height: '30%',
//         width: '100%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     seventhPageHeading: {
//         fontSize: 40,
//         fontWeight: '1000',
//         color: '#bd212f',

//     },
//     seventhPageTitleHeading: {
//         fontSize: 20,
//         fontWeight: '1000',
//         color: '#bd212f',

//     },
//     seventhPageSubheading: {
//         fontSize: 25,
//         fontWeight: 'bold',
//     },
//     seventhPageDescription: {
//         fontSize: 20,
//     },
//     seventhPageSecondContainer: {
//         height: '50%',
//         width: '100%',
//     },
//     seventhPageImageBackgroundContainer: {
//         width: '80%',
//         height: '90%',
//         position: 'absolute',
//         bottom: 0,
//         right: 0,
//         border: '5px solid #bd212f'
//     },
//     seventhPageImage: {
//         position: 'relative',
//         top: 70,
//         left: 0,
//         width: '70%',
//         height: '70%',
//         objectFit: 'cover',
//     },
//     seventhPageThirdContainer: {
//         height: '20%',
//         width: '100%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center'
//     },

//     // For eight page ==>>

//     eightPage: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'center',
//         height: '95%',
//         backgroundColor: '#bd212f',
//         margin: '5% 5% 5% 0%',


//     },
//     eightPageFirstContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         color: 'white',
//     },
//     eightPageSecondContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         color: 'white',

//     },
//     eightPageThirdContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         color: 'white',

//     },
//     eightPageFourthContainer: {
//         // backgroundColor: '#bd212f',
//         height: '20%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         color: 'white',

//     },
//     eightPageProductDetailsContainer: {
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//     },
//     eightPageProductTitle: {

//         fontSize: 15,
//         fontWeight: 'extrabold',

//     },
//     eightPageProductDescription: {
//         fontSize: 10,

//     },
//     eightPageProductPrice: {
//         fontSize: 12.5,


//     },
//     eightPageImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     eightPageImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },

//     // For ninth page ==>>
//     ninthPage: {
//         position: 'relative',
//         padding: '10%',
//     },

//     ninthPageFirstContainer: {
//         height: '30%',
//         width: '100%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     ninthPageHeading: {
//         fontSize: 40,
//         fontWeight: '1000',
//         color: '#bd212f',

//     },
//     ninthPageSubheading: {
//         fontSize: 25,
//         fontWeight: 'bold',
//     },
//     ninthPageDescription: {
//         fontSize: 20,
//     },
//     ninthPageSecondContainer: {
//         height: '50%',
//         width: '100%',
//     },
//     ninthPageImageFrontContainer: {
//         width: '60%',
//         height: '40%',
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         // backgroundColor: '#bd212f',
//         backgroundColor: '#86161b',
//         marginLeft: '5%',
//     },
//     ninthPageProductDetailsContainer: {
//         display: 'flex',
//         justifyContent: 'space-around',
//         width: '90%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//         color: 'white',
//     },
//     ninthPageProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//     },
//     ninthPageProductDescription: {
//         fontSize: 10,
//     },
//     ninthPageProductPrice: {
//         fontSize: 12.5,
//     },
//     ninthPageImage: {
//         position: 'relative',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '90%',
//         objectFit: 'cover',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//     },
//     ninthPageThirdContainer: {
//         height: '20%',
//         width: '100%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: '#bd212f',
//         color: 'white',
//         paddingLeft: '10%',
//         paddingRight: '10%',
//     },
//     ninthPageThirdContainerDescription: {
//         fontSize: 15,

//     },
//     // For tenth page ==>>

//     tenthPage: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         height: '100%',
//         // padding:'5%'
//     },
//     tenthPageUpperContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-around',
//         alignItems: 'center',
//         height: '50%',
//         width: '100%',
//     },
//     tenthPageFirstContainer: {
//         // backgroundColor: '#bd212f',
//         height: '40%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     tenthPageSecondContainer: {
//         // backgroundColor: '#bd212f',
//         height: '40%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     tenthPageLowerContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-around',
//         alignItems: 'center',
//         height: '50%',
//         width: '100%',
//         backgroundColor: '#bd212f',
//         color: 'white',
//     },
//     tenthPageThirdContainer: {
//         // backgroundColor: '#bd212f',
//         height: '40%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     tenthPageFourthContainer: {
//         // backgroundColor: '#bd212f',
//         height: '40%',
//         width: '80%',
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//     },
//     tenthPageProductDetailsContainer: {
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//     },
//     tenthPageProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//         color: '#bd212f',
//     },
//     tenthPageProductDescription: {
//         fontSize: 10,

//     },
//     tenthPageProductPrice: {
//         fontSize: 12.5,
//         color: '#bd212f',
//     },
//     tenthPageImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     tenthPageImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },
//     tenthPageLowerContainerProductDetailsContainer: {
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         width: '60%',
//         height: '100%',
//         paddingLeft: '5%',
//         paddingRight: '5%',
//     },
//     tenthPageLowerContainerProductTitle: {
//         fontSize: 15,
//         fontWeight: 'extrabold',
//     },


//     tenthPageLowerContainerProductPrice: {
//         fontSize: 12.5,
//     },
//     tenthPageLowerContainerImageContainer: {
//         width: '40%',
//         height: '100%',
//     },
//     tenthPageLowerContainerImage: {
//         objectFit: 'cover',
//         width: '100%',
//         height: '100%',
//     },
//     // For eleventh page ==>>
//     eleventhPage: {
//         position: 'relative',
//         width: '100%',
//         height: '100%',
//     },
//     lastPageBackgroundFirstBox: {
//         width: '15%',
//         height: '10%',
//         position: 'absolute',
//         top: '13%',
//         left: '50%',
//         transform: ' rotate(45deg)',
//         backgroundColor: '#bd212f',
//     },
//     lastPageBackgroundSecondBox: {
//         width: '40%',
//         height: '28%',
//         position: 'absolute',
//         top: '15%',
//         right: '-10%',
//         transform: 'rotate(45deg)',
//         backgroundColor: '#e1e3e5',
//     },
//     lastPageLogoContainer: {
//         width: '30%',
//         height: '20%',
//         position: 'absolute',
//         top: '30%',
//         left: '35%',
//         // transform: 'translate(-50%, -50%) rotate(45deg)',
//         transform: 'rotate(45deg)',
//         backgroundColor: '#bd212f',
//         justifyContent: 'center', // Center the content
//         alignItems: 'center', // Center the content
//     },
//     lastPageLogoImage: {
//         // position: 'relative',
//         // top: '10%',
//         // left: '10%',
//         // transform: 'translate(-50%, -50%)',
//         width: '80%',
//         height: 'auto',
//         resizeMode: 'contain', // Maintain aspect ratio and fit within the container

//     },
//     lastPageBottomContainer: {
//         position: 'absolute',
//         bottom: 0,
//         width: '100%',
//         height: '35%',
//         backgroundColor: '#bd212f',
//         padding: '10% 20%',
//         display: 'flex',
//         // flexDirection: 'row',
//         flexDirection: 'column',
//         justifyContent: 'space-evenly',
//         alignItems: 'center',
//         color: 'white',
//     },
//     // lastPageBottomLeftContainer: {
//     //     display: 'flex',
//     //     flexDirection: 'column',
//     //     justifyContent: 'space-evenly',
//     //     alignItems: 'flex-start',
//     //     height: '100%',
//     //     width: '50%',
//     // },
//     // lastPageBottomRightContainer: {
//     //     display: 'flex',
//     //     flexDirection: 'column',
//     //     justifyContent: 'space-evenly',
//     //     alignItems: 'flex-start',
//     //     height: '100%',
//     //     width: '50%',
//     // },
//     socialMediaIconContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-evenly',
//         alignItems: 'center',
//         height: '100%',
//         width: '100%',
//         color: 'white',
//         textDecoration: 'none'
//     },
//     socialMediaIcon: {
//         width: 40,
//         height: 40,
//         color: 'white',
//         objectFit: 'cover',
//     },
//     socialMediaIconName: {
//         fontSize: 15,
//         fontWeight: 'bold',
//         color: 'white',
//     },
//     lastPageManagerDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         width: '100%',
//         fontSize: 15,
//         textAlign: 'center',
//     },
//     lastPageManagerNameAndNumberContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'space-around'
//     },
//     lastPageStoreDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 10,
//         fontSize: 15,
//     },
//     lastpageCopyright: {
//         margin: 'auto',
//         fontSize: 10,
//     },
// });




// const truncateText = (text, maxLength) => {
//     if (!text) {
//         return '';  // Return an empty string if the text is undefined or null
//     }
//     if (text.length > maxLength) {
//         return text.substring(0, maxLength) + '...';
//     }
//     return text;
// };

// function StyleChronicles({ jsonData, vendor }) {
//     const [Data, setData] = useState();

//     useEffect(() => {
//         setData(jsonData);
//     }, [jsonData]);

//     const [products, setProducts] = useState([]);


//     // useEffect(() => {
//     //     axios.get('https://fakestoreapi.com/products')
//     //         .then(response => {
//     //             setProducts(response.data);
//     //         })
//     //         .catch(error => {
//     //             console.error('Error fetching data: ', error);
//     //         });
//     // }, []);

//     const getCurrentMonthAndYear = () => {
//         const date = new Date();
//         const monthNames = [
//             "January", "February", "March", "April", "May", "June",
//             "July", "August", "September", "October", "November", "December"
//         ];
//         const currentMonth = monthNames[date.getMonth()];
//         const currentYear = date.getFullYear();
//         return `${currentMonth} - ${currentYear}`;
//     };

//     console.log("This is the data of StyleChronicles :=>", Data);
//     console.log("IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", Data?.Product?.[0]?.image)
//     return (
//         <Document>



//             {/* First page ==>> */}
//             <Page size="A4" style={styles.frontPage}>
//                 <View style={styles.frontPageImageContainer}>
//                     <Image style={styles.frontPageImage} src="/image/frontPageImage.jpg" />
//                 </View>
//                 <View style={styles.frontPageLogoContainer}>
//                     <Image style={styles.frontPageLogoImage} src="/logoWhite.png" />
//                 </View>
//                 <View style={styles.frontPageBottomBox} />
//                 <View style={styles.frontPageHeadingContainer}>
//                     <Text style={styles.frontPageSubheading}>{Data?.Store?.storename}</Text>
//                     <Text style={styles.frontPageHeading}>PRODUCT{'\n'}CATALOG</Text>
//                     <Text style={styles.frontPageDescription}>
//                         Experience the perfect blend of quality and style with our thoughtfully crafted products.
//                     </Text>
//                 </View>
//                 <View style={styles.frontPageYearContainer}>
//                     <Text style={styles.frontPageYear}>{getCurrentMonthAndYear()}</Text>
//                 </View>
//             </Page>

//             {Data?.Product?.length === 1 ?
//                 <Page size="A4">
//                     <View style={styles.seventhPage}>
//                         <View style={styles.seventhPageBorderContainer}>
//                             <View style={styles.seventhPageFirstContainer}>
//                                 {/* <Text style={styles.seventhPageSubheading}>Try Now!</Text> */}
//                                 <Text style={styles.seventhPageHeading}>Trending Collections</Text>
//                                 <Text style={styles.seventhPageTitleHeading}>
//                                     {Data?.Product?.[0]?.title}
//                                 </Text>
//                                 <Text style={styles.seventhPageDescription}>
//                                     {Data?.Product?.[0]?.price} Rs.
//                                 </Text>
//                             </View>
//                             <View style={styles.seventhPageSecondContainer}>
//                                 <View style={styles.seventhPageImageBackgroundContainer}></View>
//                                 <Image style={styles.seventhPageImage}
//                                     src={
//                                         Data?.Product?.[0]?.image && Data?.Product?.[0]?.image !== "N/A"
//                                             ? Data?.Product?.[0]?.image
//                                             : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
//                                     }
//                                 />
//                             </View>
//                             <View style={styles.seventhPageThirdContainer}>
//                                 <Text style={styles.seventhPageDescription}>
//                                     {Data?.Product?.[0]?.description ? Data?.Product?.[0]?.description : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                 </Text>
//                             </View>
//                         </View>
//                     </View>
//                 </Page>
//                 : <>

//                     {/* seventh page ==>> */}
//                     {Data?.Product?.length <= 2 &&
//                         <>
//                             <Page size="A4">
//                                 <View style={styles.seventhPage}>
//                                     <View style={styles.seventhPageBorderContainer}>
//                                         <View style={styles.seventhPageFirstContainer}>
//                                             {/* <Text style={styles.seventhPageSubheading}>Try Now!</Text> */}
//                                             <Text style={styles.seventhPageHeading}>Trending Collections</Text>
//                                             <Text style={styles.seventhPageTitleHeading}>
//                                                 {Data?.Product?.[0]?.title}
//                                             </Text>
//                                             <Text style={styles.seventhPageDescription}>
//                                                 {Data?.Product?.[0]?.price} Rs.
//                                             </Text>
//                                         </View>
//                                         <View style={styles.seventhPageSecondContainer}>
//                                             <View style={styles.seventhPageImageBackgroundContainer}></View>
//                                             <Image style={styles.seventhPageImage} src={
//                                                 Data?.Product?.[0]?.image && Data?.Product?.[0]?.image !== "N/A"
//                                                     ? Data?.Product?.[0]?.image
//                                                     : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
//                                             } />
//                                         </View>
//                                         <View style={styles.seventhPageThirdContainer}>
//                                             <Text style={styles.seventhPageDescription}>
//                                                 {Data?.Product?.[0]?.description ? Data?.Product?.[0]?.description : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                             </Text>
//                                         </View>
//                                     </View>
//                                 </View>
//                             </Page>

//                             <Page size="A4">
//                                 <View style={styles.ninthPage}>
//                                     <View style={styles.ninthPageFirstContainer}>
//                                         {/* <Text style={styles.ninthPageSubheading}>Try Now!</Text> */}
//                                         <Text style={styles.ninthPageHeading}>Trending Collections</Text>
//                                         <Text style={styles.ninthPageDescription}>
//                                             {Data?.Product?.[1]?.price} Rs.
//                                         </Text>
//                                     </View>
//                                     <View style={styles.ninthPageSecondContainer}>
//                                         <Image style={styles.ninthPageImage} src={
//                                             Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
//                                                 ? Data?.Product?.[1]?.image
//                                                 : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
//                                         } />
//                                         <View style={styles.ninthPageImageFrontContainer}>
//                                             <View style={styles.ninthPageProductDetailsContainer}>
//                                                 <Text style={styles.ninthPageProductTitle}>{Data?.Product?.[1]?.title}</Text>
//                                                 {/* <Text style={styles.ninthPageProductDescription}>{truncateText(products[17]?.description, 100)}</Text>
//                                                 <Text style={styles.ninthPageProductPrice}>{products[17]?.price}</Text> */}
//                                             </View>
//                                         </View>
//                                     </View>
//                                     <View style={styles.ninthPageThirdContainer}>
//                                         <Text style={styles.ninthPageThirdContainerDescription}>
//                                             {Data?.Product?.[1]?.description ? Data?.Product?.[1]?.description : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                         </Text>
//                                     </View>
//                                 </View>
//                             </Page>
//                         </>
//                     }

//                     {/* ninth page ==>> */}
//                     {/* {Data?.Product?.length <= 2 &&
//                         <Page size="A4">
//                             <View style={styles.ninthPage}>
//                                 <View style={styles.ninthPageFirstContainer}>
//                                     <Text style={styles.ninthPageHeading}>Trending Collections</Text>
//                                     <Text style={styles.ninthPageDescription}>
//                                         {Data?.Product?.[1]?.price} Rs.
//                                     </Text>
//                                 </View>
//                                 <View style={styles.ninthPageSecondContainer}>
//                                     <Image style={styles.ninthPageImage} src={
//             Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
//                 ? Data?.Product?.[1]?.image
//                 : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
//         } />
//                                     <View style={styles.ninthPageImageFrontContainer}>
//                                         <View style={styles.ninthPageProductDetailsContainer}>
//                                             <Text style={styles.ninthPageProductTitle}>{Data?.Product?.[1]?.title}</Text>
//                                         </View>
//                                     </View>
//                                 </View>
//                                 <View style={styles.ninthPageThirdContainer}>
//                                     <Text style={styles.ninthPageThirdContainerDescription}>
//                                         {Data?.Product?.[1]?.description ? Data?.Product?.[1]?.description : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                     </Text>
//                                 </View>
//                             </View>
//                         </Page>
//                     } */}


//                     {/* seventh page ==>> */}
//                     {Data?.Product?.length === 4 &&
//                         <Page size="A4">
//                             <View style={styles.seventhPage}>
//                                 <View style={styles.seventhPageBorderContainer}>
//                                     <View style={styles.seventhPageFirstContainer}>
//                                         {/* <Text style={styles.seventhPageSubheading}>Try Now!</Text> */}
//                                         <Text style={styles.seventhPageHeading}>Trending Collections</Text>
//                                         <Text style={styles.seventhPageTitleHeading}>
//                                             {Data?.Product?.[3]?.title}
//                                         </Text>
//                                         <Text style={styles.seventhPageDescription}>
//                                             {Data?.Product?.[3]?.price} Rs.
//                                         </Text>
//                                     </View>
//                                     <View style={styles.seventhPageSecondContainer}>
//                                         <View style={styles.seventhPageImageBackgroundContainer}></View>
//                                         <Image style={styles.seventhPageImage} src={
//                                             Data?.Product?.[3]?.image && Data?.Product?.[3]?.image !== "N/A"
//                                                 ? Data?.Product?.[3]?.image
//                                                 : Data?.Product?.[3]?.productImage // Fallback to Data?.Product?.[3]?.productImage
//                                         } />
//                                     </View>
//                                     <View style={styles.seventhPageThirdContainer}>
//                                         <Text style={styles.seventhPageDescription}>
//                                             {Data?.Product?.[3]?.description ? Data?.Product?.[3]?.description : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                         </Text>
//                                     </View>
//                                 </View>
//                             </View>
//                         </Page>
//                     }

//                     {/* Fifth page ==>> */}
//                     {Data?.Product?.length >= 3 &&
//                         <Page size="A4" style={styles.page}>
//                             <View style={styles.fifthPage}>
//                                 <View style={styles.fifthPageFirstContainer}>
//                                     <View style={styles.fifthPageFirstUpperContainer}>
//                                         <Text style={styles.fifthPageSubheading}>Try Now!</Text>
//                                         <Text style={styles.fifthPageHeading}>Trending Collections</Text>
//                                     </View>
//                                     <View style={styles.fifthPageFirstLowerContainer}>
//                                         <View style={styles.fifthPageFirstLowerContainerProductDetailsContainer}>
//                                             <Text style={styles.fifthPageFirstLowerContainerProductTitle}>{Data?.Product?.[0]?.title}</Text>
//                                             <Text style={styles.fifthPageFirstLowerContainerProductDescription}>
//                                                 {truncateText(
//                                                     Data?.Product?.[0]?.description
//                                                         ? Data?.Product?.[0]?.description
//                                                         : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                                     100
//                                                 )}
//                                             </Text>
//                                             <Text style={styles.fifthPageFirstLowerContainerProductPrice}>{Data?.Product?.[0]?.price}</Text>
//                                         </View>
//                                         <View style={styles.fifthPageImageContainer}>
//                                             <Image style={styles.fifthPageImage} src={
//                                                 Data?.Product?.[0]?.image && Data?.Product?.[0]?.image !== "N/A"
//                                                     ? Data?.Product?.[0]?.image
//                                                     : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
//                                             } />
//                                         </View>
//                                     </View>
//                                 </View>
//                                 <View style={styles.fifthPageSecondContainer}>
//                                     <View style={styles.fifthPageSecondLeftContainer}>
//                                         <View style={styles.fifthPageSecondLeftContainerProductDetailsContainer}>
//                                             <Text style={styles.fifthPageSecondLeftContainerProductTitle}>{Data?.Product?.[1]?.title}</Text>
//                                             <Text style={styles.fifthPageSecondLeftContainerProductDescription}>{truncateText(
//                                                 Data?.Product?.[1]?.description
//                                                     ? Data?.Product?.[1]?.description
//                                                     : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                                 100
//                                             )}</Text>
//                                             <Text style={styles.fifthPageSecondLeftContainerProductPrice}>{Data?.Product?.[1]?.price}</Text>
//                                         </View>
//                                         <View style={styles.fifthPageSecondLeftContainerImageContainer}>
//                                             <Image style={styles.fifthPageSecondLeftContainerImage} src={
//                                                 Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
//                                                     ? Data?.Product?.[1]?.image
//                                                     : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
//                                             } />
//                                         </View>
//                                     </View>
//                                     <View style={styles.fifthPageVerticalLine} />
//                                     <View style={styles.fifthPageSecondRightContainer}>
//                                         <View style={styles.fifthPageSecondRightContainerProductDetailsContainer}>
//                                             <Text style={styles.fifthPageSecondRightContainerProductTitle}>{Data?.Product?.[2]?.title}</Text>
//                                             <Text style={styles.fifthPageSecondRightContainerProductDescription}>{truncateText(
//                                                 Data?.Product?.[2]?.description
//                                                     ? Data?.Product?.[2]?.description
//                                                     : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                                 100
//                                             )}</Text>
//                                             <Text style={styles.fifthPageSecondRightContainerProductPrice}>{Data?.Product?.[2]?.price}</Text>
//                                         </View>
//                                         <View style={styles.fifthPageSecondRightContainerImageContainer}>
//                                             <Image style={styles.fifthPageSecondRightContainerImage} src={
//                                                 Data?.Product?.[2]?.image && Data?.Product?.[2]?.image !== "N/A"
//                                                     ? Data?.Product?.[2]?.image
//                                                     : Data?.Product?.[2]?.productImage // Fallback to Data?.Product?.[2]?.productImage
//                                             } />
//                                         </View>
//                                     </View>
//                                 </View>
//                             </View>
//                         </Page>
//                     }

//                     {/* Third page ==>> */}
//                     {(Data?.Product?.length > 4) &&
//                         <Page size="A4">
//                             <View style={styles.thirdPage}>
//                                 <View style={styles.thirdPageFirstContainer}>
//                                     <Text style={styles.thirdPageSubheading}>Try Now!</Text>
//                                     <Text style={styles.thirdPageHeading}>Trending Collections</Text>
//                                     <Text style={styles.thirdPageDescription}>
//                                         Experience the perfect blend of quality and style with our thoughtfully crafted products.
//                                     </Text>
//                                 </View>

//                                 <View style={styles.thirdPageSecondContainer}>
//                                     <View style={styles.thirdPageProductDetailsContainer}>
//                                         <Text style={styles.thirdPageProductTitle}>{Data?.Product?.[3]?.title}</Text>
//                                         <Text style={styles.thirdPageProductDescription}>{truncateText(
//                                             Data?.Product?.[3]?.description
//                                                 ? Data?.Product?.[3]?.description
//                                                 : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                             100
//                                         )}</Text>
//                                         <Text style={styles.thirdPageProductPrice}>{Data?.Product?.[3]?.price} Rs.</Text>
//                                     </View>
//                                     <View style={styles.thirdPageImageContainer}>
//                                         <Image style={styles.thirdPageImage} src={
//                                             Data?.Product?.[3]?.image && Data?.Product?.[3]?.image !== "N/A"
//                                                 ? Data?.Product?.[3]?.image
//                                                 : Data?.Product?.[3]?.productImage // Fallback to Data?.Product?.[3]?.productImage
//                                         } />
//                                     </View>
//                                 </View>
//                                 <View style={styles.thirdPageThirdContainer}>
//                                     <View style={styles.thirdPageProductDetailsContainer}>
//                                         <Text style={styles.thirdPageProductTitle}>{Data?.Product?.[4]?.title}</Text>
//                                         <Text style={styles.thirdPageProductDescription}>{truncateText(
//                                             Data?.Product?.[4]?.description
//                                                 ? Data?.Product?.[4]?.description
//                                                 : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                             100
//                                         )}</Text>
//                                         <Text style={styles.thirdPageProductPrice}>{Data?.Product?.[4]?.price} Rs.</Text>
//                                     </View>
//                                     <View style={styles.thirdPageImageContainer}>
//                                         <Image style={styles.thirdPageImage} src={
//                                             Data?.Product?.[4]?.image && Data?.Product?.[4]?.image !== "N/A"
//                                                 ? Data?.Product?.[4]?.image
//                                                 : Data?.Product?.[4]?.productImage // Fallback to Data?.Product?.[4]?.productImage
//                                         } />
//                                     </View>
//                                 </View>
//                                 {Data?.Product?.length > 5 &&
//                                     < View style={styles.thirdPageFourthContainer}>
//                                         <View style={styles.thirdPageImageContainer}>
//                                             <Image style={styles.thirdPageImage} src={
//                                                 Data?.Product?.[5]?.image && Data?.Product?.[5]?.image !== "N/A"
//                                                     ? Data?.Product?.[5]?.image
//                                                     : Data?.Product?.[5]?.productImage // Fallback to Data?.Product?.[5]?.productImage
//                                             } />
//                                         </View>
//                                         <View style={styles.thirdPageProductDetailsContainer}>
//                                             <Text style={styles.thirdPageProductTitle}>{Data?.Product?.[5]?.title}</Text>
//                                             <Text style={styles.thirdPageProductDescription}>{truncateText(
//                                                 Data?.Product?.[5]?.description
//                                                     ? Data?.Product?.[5]?.description
//                                                     : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                                 100
//                                             )}</Text>
//                                             <Text style={styles.thirdPageProductPrice}>{Data?.Product?.[5]?.price}</Text>
//                                         </View>
//                                     </View>
//                                 }
//                             </View>
//                         </Page>
//                     }

//                     {/* ninth page ==>> */}
//                     {Data?.Product?.length === 7 &&
//                         <Page size="A4">
//                             <View style={styles.ninthPage}>
//                                 <View style={styles.ninthPageFirstContainer}>
//                                     {/* <Text style={styles.ninthPageSubheading}>Try Now!</Text> */}
//                                     <Text style={styles.ninthPageHeading}>Trending Collections</Text>
//                                     <Text style={styles.ninthPageDescription}>
//                                         {Data?.Product?.[6]?.price} Rs.
//                                     </Text>
//                                 </View>
//                                 <View style={styles.ninthPageSecondContainer}>
//                                     <Image style={styles.ninthPageImage} src={
//                                         Data?.Product?.[6]?.image && Data?.Product?.[6]?.image !== "N/A"
//                                             ? Data?.Product?.[6]?.image
//                                             : Data?.Product?.[6]?.productImage // Fallback to Data?.Product?.[6]?.productImage
//                                     } />
//                                     <View style={styles.ninthPageImageFrontContainer}>
//                                         <View style={styles.ninthPageProductDetailsContainer}>
//                                             <Text style={styles.ninthPageProductTitle}>{Data?.Product?.[6]?.title}</Text>
//                                             {/* <Text style={styles.ninthPageProductDescription}>{truncateText(products[17]?.description, 100)}</Text>
//                                     <Text style={styles.ninthPageProductPrice}>{products[17]?.price}</Text> */}
//                                         </View>
//                                     </View>
//                                 </View>
//                                 <View style={styles.ninthPageThirdContainer}>
//                                     <Text style={styles.ninthPageThirdContainerDescription}>
//                                         {Data?.Product?.[6]?.description ? Data?.Product?.[6]?.description : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                     </Text>
//                                 </View>
//                             </View>
//                         </Page>
//                     }

//                     {/* eight page ==>> */}
//                     {(Data?.Product?.length > 7) &&
//                         <Page size="A4" style={styles.page}>
//                             <View style={styles.eightPage}>
//                                 <View style={styles.eightPageFirstContainer}>
//                                     <View style={styles.eightPageImageContainer}>
//                                         <Image style={styles.eightPageImage} src={
//                                             Data?.Product?.[6]?.image && Data?.Product?.[6]?.image !== "N/A"
//                                                 ? Data?.Product?.[6]?.image
//                                                 : Data?.Product?.[6]?.productImage // Fallback to Data?.Product?.[6]?.productImage
//                                         } />
//                                     </View>
//                                     <View style={styles.eightPageProductDetailsContainer}>
//                                         <Text style={styles.eightPageProductTitle}>{Data?.Product?.[6]?.title}</Text>
//                                         <Text style={styles.eightPageProductDescription}>{truncateText(
//                                             Data?.Product?.[6]?.description
//                                                 ? Data?.Product?.[6]?.description
//                                                 : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                             100
//                                         )}</Text>
//                                         <Text style={styles.eightPageProductPrice}>{Data?.Product?.[6]?.price}</Text>
//                                     </View>
//                                 </View>
//                                 <View style={styles.eightPageSecondContainer}>
//                                     <View style={styles.eightPageImageContainer}>
//                                         <Image style={styles.eightPageImage} src={
//                                             Data?.Product?.[7]?.image && Data?.Product?.[7]?.image !== "N/A"
//                                                 ? Data?.Product?.[7]?.image
//                                                 : Data?.Product?.[7]?.productImage // Fallback to Data?.Product?.[7]?.productImage
//                                         } />
//                                     </View>
//                                     <View style={styles.eightPageProductDetailsContainer}>
//                                         <Text style={styles.eightPageProductTitle}>{Data?.Product?.[7]?.title}</Text>
//                                         <Text style={styles.eightPageProductDescription}>{truncateText(
//                                             Data?.Product?.[7]?.description
//                                                 ? Data?.Product?.[7]?.description
//                                                 : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                             100
//                                         )}</Text>
//                                         <Text style={styles.eightPageProductPrice}>{Data?.Product?.[7]?.price}</Text>
//                                     </View>
//                                 </View>
//                                 {(Data?.Product?.length > 8) &&
//                                     <View style={styles.eightPageThirdContainer}>
//                                         <View style={styles.eightPageImageContainer}>
//                                             <Image style={styles.fourthPageImage} src={
//                                                 Data?.Product?.[8]?.image && Data?.Product?.[8]?.image !== "N/A"
//                                                     ? Data?.Product?.[8]?.image
//                                                     : Data?.Product?.[8]?.productImage // Fallback to Data?.Product?.[8]?.productImage
//                                             } />
//                                         </View>
//                                         <View style={styles.eightPageProductDetailsContainer}>
//                                             <Text style={styles.eightPageProductTitle}>{Data?.Product?.[8]?.title}</Text>
//                                             <Text style={styles.eightPageProductDescription}>{truncateText(
//                                                 Data?.Product?.[8]?.description
//                                                     ? Data?.Product?.[8]?.description
//                                                     : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                                 100
//                                             )}</Text>
//                                             <Text style={styles.eightPageProductPrice}>{Data?.Product?.[8]?.price}</Text>
//                                         </View>
//                                     </View>
//                                 }
//                                 {(Data?.Product?.length === 10) &&
//                                     <View style={styles.eightPageFourthContainer}>
//                                         <View style={styles.eightPageImageContainer}>
//                                             <Image style={styles.eightPageImage} src={
//                                                 Data?.Product?.[9]?.image && Data?.Product?.[9]?.image !== "N/A"
//                                                     ? Data?.Product?.[9]?.image
//                                                     : Data?.Product?.[9]?.productImage // Fallback to Data?.Product?.[9]?.productImage
//                                             } />
//                                         </View>
//                                         <View style={styles.eightPageProductDetailsContainer}>
//                                             <Text style={styles.eightPageProductTitle}>{Data?.Product?.[9]?.title}</Text>
//                                             <Text style={styles.eightPageProductDescription}>{truncateText(
//                                                 Data?.Product?.[9]?.description
//                                                     ? Data?.Product?.[9]?.description
//                                                     : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
//                                                 100
//                                             )}</Text>
//                                             <Text style={styles.eightPageProductPrice}>{Data?.Product?.[9]?.price}</Text>
//                                         </View>
//                                     </View>
//                                 }
//                             </View>
//                         </Page>
//                     }

//                     {Data?.Product?.length >= 11 &&
//                         Data.Product.map((product, index) => (
//                             index % 2 === 0 ? (
//                                 // First Page Layout
//                                 <Page size="A4" key={`page-even-${index}`}>
//                                     <View style={styles.seventhPage}>
//                                         <View style={styles.seventhPageBorderContainer}>
//                                             <View style={styles.seventhPageFirstContainer}>
//                                                 <Text style={styles.seventhPageHeading}>Trending Collections</Text>
//                                                 <Text style={styles.seventhPageTitleHeading}>{product.title}</Text>
//                                                 <Text style={styles.seventhPageDescription}>{product.price} Rs.</Text>
//                                             </View>
//                                             <View style={styles.seventhPageSecondContainer}>
//                                                 <View style={styles.seventhPageImageBackgroundContainer}></View>
//                                                 <Image style={styles.seventhPageImage} src={
//                                                     product.image && product.image !== "N/A"
//                                                         ? product.image
//                                                         : product.productImage // Fallback to product.productImage
//                                                 } />
//                                             </View>
//                                             <View style={styles.seventhPageThirdContainer}>
//                                                 <Text style={styles.seventhPageDescription}>
//                                                     {product.description
//                                                         ? product.description
//                                                         : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                                 </Text>
//                                             </View>
//                                         </View>
//                                     </View>
//                                 </Page>
//                             ) : (
//                                 // Second Page Layout
//                                 <Page size="A4" key={`page-odd-${index}`}>
//                                     <View style={styles.ninthPage}>
//                                         <View style={styles.ninthPageFirstContainer}>
//                                             <Text style={styles.ninthPageHeading}>Trending Collections</Text>
//                                             <Text style={styles.ninthPageDescription}>{product.price} Rs.</Text>
//                                         </View>
//                                         <View style={styles.ninthPageSecondContainer}>
//                                             <Image style={styles.ninthPageImage} src={
//                                                 product.image && product.image !== "N/A"
//                                                     ? product.image
//                                                     : product.productImage // Fallback to product.productImage
//                                             } />
//                                             <View style={styles.ninthPageImageFrontContainer}>
//                                                 <View style={styles.ninthPageProductDetailsContainer}>
//                                                     <Text style={styles.ninthPageProductTitle}>{product.title}</Text>
//                                                 </View>
//                                             </View>
//                                         </View>
//                                         <View style={styles.ninthPageThirdContainer}>
//                                             <Text style={styles.ninthPageThirdContainerDescription}>
//                                                 {product.description
//                                                     ? product.description
//                                                     : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
//                                             </Text>
//                                         </View>
//                                     </View>
//                                 </Page>
//                             )
//                         ))}


//                 </>}


//             {/* Start from here */}


//             {/* second page ==>> */}
//             {/* <Page size="A4">
//                 <View style={styles.tableofcontentPage}>
//                     <View style={styles.tableofcontentPageFirstContainer}>
//                         <Text style={styles.tableofcontentPageSubheading}>Table of</Text>
//                         <Text style={styles.tableofcontentPageHeading}>Content</Text>
//                         <Text style={styles.tableofcontentPageDescription}>
//                             Experience the perfect blend of quality and style with our thoughtfully crafted products.
//                         </Text>
//                     </View>
//                     <View style={styles.tableofcontentPageSecondContainer}>
//                         <View style={styles.tableofcontentPageImageContainer}>
//                             <Image style={styles.tableofcontentPageImage} src={products[4]?.image} />
//                         </View>
//                         <View style={styles.tableofcontentPageProductDetailsContainer}>
//                             <View style={styles.tableofcontentPageProductDetails}>
//                                 <Text style={styles.tableofcontentPageProductTitle}>{products[4]?.title}</Text>
//                                 <Text style={styles.tableofcontentPageProductDescription}>{products[4]?.description}</Text>
//                                 <Text style={styles.tableofcontentPageProductPrice}>{products[4]?.price}</Text>
//                             </View>
//                             <View style={styles.tableofcontentVerticalLine} />
//                             <View>
//                                 <Text style={styles.tableofcontentPageProductTitle}>02</Text>
//                             </View>
//                         </View>
//                     </View>
//                     <View style={styles.tableofcontentPageThirdContainer}>
//                         <View style={styles.tableofcontentPageImageContainer}>
//                             <Image style={styles.tableofcontentPageImage} src={products[5]?.image} />
//                         </View>
//                         <View style={styles.tableofcontentPageProductDetailsContainer}>
//                             <View style={styles.tableofcontentPageProductDetails}>
//                                 <Text style={styles.tableofcontentPageProductTitle}>{products[5]?.title}</Text>
//                                 <Text style={styles.tableofcontentPageProductDescription}>{products[5]?.description}</Text>
//                                 <Text style={styles.tableofcontentPageProductPrice}>{products[5]?.price}</Text>
//                             </View>
//                             <View style={styles.tableofcontentVerticalLine} />
//                             <View>
//                                 <Text style={styles.tableofcontentPageProductTitle}>04</Text>
//                             </View>
//                         </View>
//                     </View>
//                     <View style={styles.tableofcontentPageFourthContainer}>
//                         <View style={styles.tableofcontentPageImageContainer}>
//                             <Image style={styles.tableofcontentPageImage} src={products[6]?.image} />
//                         </View>
//                         <View style={styles.tableofcontentPageProductDetailsContainer}>
//                             <View style={styles.tableofcontentPageProductDetails}>
//                                 <Text style={styles.tableofcontentPageProductTitle}>{products[6]?.title}</Text>
//                                 <Text style={styles.tableofcontentPageProductDescription}>{products[6]?.description}</Text>
//                                 <Text style={styles.tableofcontentPageProductPrice}>{products[6]?.price}</Text>
//                             </View>
//                             <View style={styles.tableofcontentVerticalLine} />
//                             <View>
//                                 <Text style={styles.tableofcontentPageProductTitle}>08</Text>
//                             </View>
//                         </View>
//                     </View>
//                 </View>
//             </Page> */}



//             {/* Fourth page ==>> */}
//             {/* <Page size="A4" style={styles.page}>
//                 <View style={styles.fourthPage}>
//                     <View style={styles.fourthPageFirstContainer}>
//                         <View style={styles.fourthPageImageContainer}>
//                             <Image style={styles.fourthPageImage} src={products[3]?.image} />
//                         </View>
//                         <View style={styles.fourthPageProductDetailsContainer}>
//                             <Text style={styles.fourthPageProductTitle}>{products[3]?.title}</Text>
//                             <Text style={styles.fourthPageProductDescription}>{truncateText(products[3]?.description, 100)}</Text>
//                             <Text style={styles.fourthPageProductPrice}>{products[3]?.price}</Text>
//                         </View>
//                     </View>
//                     <View style={styles.fourthPageSecondContainer}>
//                         <View style={styles.fourthPageImageContainer}>
//                             <Image style={styles.fourthPageImage} src={products[4]?.image} />
//                         </View>
//                         <View style={styles.fourthPageProductDetailsContainer}>
//                             <Text style={styles.fourthPageProductTitle}>{products[4]?.title}</Text>
//                             <Text style={styles.fourthPageProductDescription}>{truncateText(products[4]?.description, 100)}</Text>
//                             <Text style={styles.fourthPageProductPrice}>{products[4]?.price}</Text>
//                         </View>
//                     </View>
//                     <View style={styles.fourthPageThirdContainer}>
//                         <View style={styles.fourthPageImageContainer}>
//                             <Image style={styles.fourthPageImage} src={products[5]?.image} />
//                         </View>
//                         <View style={styles.fourthPageProductDetailsContainer}>
//                             <Text style={styles.fourthPageProductTitle}>{products[5]?.title}</Text>
//                             <Text style={styles.fourthPageProductDescription}>{truncateText(products[5]?.description, 100)}</Text>
//                             <Text style={styles.fourthPageProductPrice}>{products[5]?.price}</Text>
//                         </View>
//                     </View>
//                     <View style={styles.fourthPageFourthContainer}>
//                         <View style={styles.fourthPageImageContainer}>
//                             <Image style={styles.fourthPageImage} src={products[6]?.image} />
//                         </View>
//                         <View style={styles.fourthPageProductDetailsContainer}>
//                             <Text style={styles.fourthPageProductTitle}>{products[6]?.title}</Text>
//                             <Text style={styles.fourthPageProductDescription}>{truncateText(products[6]?.description, 100)}</Text>
//                             <Text style={styles.fourthPageProductPrice}>{products[6]?.price}</Text>
//                         </View>
//                     </View>
//                 </View>
//             </Page> */}



//             {/* sixth page ==>> */}
//             {/* <Page size="A4" style={styles.page}>
//                 <View style={styles.sixthPage}>
//                     <View style={styles.sixthPageFirstContainer}>
//                         <View style={styles.sixthPageFirstUpperContainer}>
//                             <Text style={styles.sixthPageSubheading}>Try Now!</Text>
//                             <Text style={styles.sixthPageHeading}>Party Collections</Text>
//                         </View>
//                         <View style={styles.sixthPageFirstLowerContainer}>
//                             <View style={styles.sixthPageImageContainer}>
//                                 <Image style={styles.sixthPageImage} src={products[10]?.image} />
//                             </View>
//                             <View style={styles.sixthPageFirstLowerContainerProductDetailsContainer}>
//                                 <Text style={styles.sixthPageFirstLowerContainerProductTitle}>{products[10]?.title}</Text>
//                                 <Text style={styles.sixthPageFirstLowerContainerProductDescription}>{truncateText(products[10]?.description, 100)}</Text>
//                                 <Text style={styles.sixthPageFirstLowerContainerProductPrice}>{products[10]?.price}</Text>
//                             </View>
//                         </View>
//                     </View>
//                     <View style={styles.sixthPageSecondContainer}>
//                         <View style={styles.sixthPageSecondLeftContainer}>
//                             <View style={styles.sixthPageSecondLeftContainerProductDetailsContainer}>
//                                 <Text style={styles.sixthPageSecondLeftContainerProductTitle}>{products[11]?.title}</Text>
//                                 <Text style={styles.sixthPageSecondLeftContainerProductDescription}>{truncateText(products[11]?.description, 100)}</Text>
//                                 <Text style={styles.sixthPageSecondLeftContainerProductPrice}>{products[11]?.price}</Text>
//                             </View>
//                             <View style={styles.sixthPageSecondLeftContainerImageContainer}>
//                                 <Image style={styles.sixthPageSecondLeftContainerImage} src={products[11]?.image} />
//                             </View>
//                         </View>
//                         <View style={styles.sixthPageVerticalLine} />
//                         <View style={styles.sixthPageSecondRightContainer}>
//                             <View style={styles.sixthPageSecondRightContainerProductDetailsContainer}>
//                                 <Text style={styles.sixthPageSecondRightContainerProductTitle}>{products[12]?.title}</Text>
//                                 <Text style={styles.sixthPageSecondRightContainerProductDescription}>{truncateText(products[12]?.description, 100)}</Text>
//                                 <Text style={styles.sixthPageSecondRightContainerProductPrice}>{products[12]?.price}</Text>
//                             </View>
//                             <View style={styles.sixthPageSecondRightContainerImageContainer}>
//                                 <Image style={styles.sixthPageSecondRightContainerImage} src={products[12]?.image} />
//                             </View>
//                         </View>
//                     </View>
//                 </View>
//             </Page> */}




//             {/* eight page ==>> */}
//             {/* <Page size="A4" style={styles.page}>
//                 <View style={styles.eightPage}>
//                     <View style={styles.eightPageFirstContainer}>
//                         <View style={styles.eightPageImageContainer}>
//                             <Image style={styles.eightPageImage} src={products[13]?.image} />
//                         </View>
//                         <View style={styles.eightPageProductDetailsContainer}>
//                             <Text style={styles.eightPageProductTitle}>{products[13]?.title}</Text>
//                             <Text style={styles.eightPageProductDescription}>{truncateText(products[13]?.description, 100)}</Text>
//                             <Text style={styles.eightPageProductPrice}>{products[13]?.price}</Text>
//                         </View>
//                     </View>
//                     <View style={styles.eightPageSecondContainer}>
//                         <View style={styles.eightPageImageContainer}>
//                             <Image style={styles.eightPageImage} src={products[14]?.image} />
//                         </View>
//                         <View style={styles.eightPageProductDetailsContainer}>
//                             <Text style={styles.eightPageProductTitle}>{products[14]?.title}</Text>
//                             <Text style={styles.eightPageProductDescription}>{truncateText(products[14]?.description, 100)}</Text>
//                             <Text style={styles.eightPageProductPrice}>{products[14]?.price}</Text>
//                         </View>
//                     </View>
//                     <View style={styles.eightPageThirdContainer}>
//                         <View style={styles.eightPageImageContainer}>
//                             <Image style={styles.fourthPageImage} src={products[15]?.image} />
//                         </View>
//                         <View style={styles.eightPageProductDetailsContainer}>
//                             <Text style={styles.eightPageProductTitle}>{products[15]?.title}</Text>
//                             <Text style={styles.eightPageProductDescription}>{truncateText(products[15]?.description, 100)}</Text>
//                             <Text style={styles.eightPageProductPrice}>{products[15]?.price}</Text>
//                         </View>
//                     </View>
//                     <View style={styles.eightPageFourthContainer}>
//                         <View style={styles.eightPageImageContainer}>
//                             <Image style={styles.eightPageImage} src={products[16]?.image} />
//                         </View>
//                         <View style={styles.eightPageProductDetailsContainer}>
//                             <Text style={styles.eightPageProductTitle}>{products[16]?.title}</Text>
//                             <Text style={styles.eightPageProductDescription}>{truncateText(products[16]?.description, 100)}</Text>
//                             <Text style={styles.eightPageProductPrice}>{products[16]?.price}</Text>
//                         </View>
//                     </View>
//                 </View>
//             </Page> */}


//             {/* tenth page ==>> */}
//             {/* <Page size="A4" style={styles.page}>
//                 <View style={styles.tenthPage}>
//                     <View style={styles.tenthPageUpperContainer}>
//                         <View style={styles.tenthPageFirstContainer}>
//                             <View style={styles.tenthPageImageContainer}>
//                                 <Image style={styles.tenthPageImage} src={products[18]?.image} />
//                             </View>
//                             <View style={styles.tenthPageProductDetailsContainer}>
//                                 <Text style={styles.tenthPageProductTitle}>{products[18]?.title}</Text>
//                                 <Text style={styles.tenthPageProductDescription}>{truncateText(products[18]?.description, 100)}</Text>
//                                 <Text style={styles.tenthPageProductPrice}>{products[18]?.price}</Text>
//                             </View>
//                         </View>
//                         <View style={styles.tenthPageSecondContainer}>
//                             <View style={styles.tenthPageImageContainer}>
//                                 <Image style={styles.tenthPageImage} src={products[19]?.image} />
//                             </View>
//                             <View style={styles.tenthPageProductDetailsContainer}>
//                                 <Text style={styles.tenthPageProductTitle}>{products[19]?.title}</Text>
//                                 <Text style={styles.tenthPageProductDescription}>{truncateText(products[19]?.description, 100)}</Text>
//                                 <Text style={styles.tenthPageProductPrice}>{products[19]?.price}</Text>
//                             </View>
//                         </View>
//                     </View>

//                     <View style={styles.tenthPageLowerContainer}>
//                         <View style={styles.tenthPageThirdContainer}>
//                             <View style={styles.tenthPageLowerContainerImageContainer}>
//                                 <Image style={styles.tenthPageLowerContainerImage} src={products[12]?.image} />
//                             </View>
//                             <View style={styles.tenthPageProductDetailsContainer}>
//                                 <Text style={styles.tenthPageLowerContainerProductTitle}>{products[12]?.title}</Text>
//                                 <Text style={styles.tenthPageProductDescription}>{truncateText(products[12]?.description, 100)}</Text>
//                                 <Text style={styles.tenthPageLowerContainerProductPrice}>{products[12]?.price}</Text>
//                             </View>
//                         </View>
//                         <View style={styles.tenthPageFourthContainer}>
//                             <View style={styles.tenthPageLowerContainerImageContainer}>
//                                 <Image style={styles.tenthPageLowerContainerImage} src={products[8]?.image} />
//                             </View>
//                             <View style={styles.tenthPageLowerContainerProductDetailsContainer}>
//                                 <Text style={styles.tenthPageLowerContainerProductTitle}>{products[8]?.title}</Text>
//                                 <Text style={styles.tenthPageProductDescription}>{truncateText(products[8]?.description, 100)}</Text>
//                                 <Text style={styles.tenthPageLowerContainerProductPrice}>{products[8]?.price}</Text>
//                             </View>
//                         </View>
//                     </View>
//                 </View>
//             </Page> */}

//             {/* eleventh page ==>> */}
//            <Page size="A4" style={styles.page}>
//                          {/* <View style={styles.lastPageBackground} /> */}
//                          {/* <View style={styles.lastPageUpperContainer}> */}
//                              {/* <View style={styles.lastPageContentContainer}> */}
//                                  <View style={styles.lastPageLogoImageContainer}>
//                                      <Image
//                                          style={styles.lastPageLogoImage}
//                                          // src={(vendor?.vendorDetails?.logo?.url) ? vendor?.vendorDetails?.logo?.url : "/logo.png"}
//                                          // src="https://storage.googleapis.com/fixlabsinficonnect/documents/20241206T122850788Z-1d8e1c615e90f989f299e273e3b7bcaa%20(1).png"
//                                          src="/logo.png"
//                                      />
//                                  </View>
         
         
         
         
         
         
//                                  {/* <View style={styles.lastPageManagerDetailsContainer}>
//                                      <View style={styles.lastPageManagerNameAndNumberContainer}>
//                                          <Text style={styles.lastPageManagerName}>{Data?.Store?.managername}</Text>
//                                          <Text style={styles.lastPageManagerPhoneNumber}>{Data?.Store?.storePhone}</Text>
//                                      </View>
//                                      <View style={styles.lastPageManagerEmailContainer}>
//                                          <Text style={styles.lastPageManagerName}>Pranjal.Sengar@gmail.com</Text>
//                                      </View>
//                                  </View> */}
//                                  {/* <View style={styles.lastPageStoreDetailsContainer}> */}
         
//                                      {/* <View style={styles.storeLocationContainer}>
//                                          <Text style={styles.storeLocation}>{Data?.Store?.storeAddress}</Text>
//                                      </View> */}
         
//                                      {/* <View style={styles.socialLinks}>
//                                          <Link src="https://www.facebook.com/login.php" style={styles.iconLink}>
//                                              <Image
//                                                  src="/images/facebookLogoBlue.png"
//                                                  style={styles.icon}
//                                                  alt="Facebook"
//                                              />
//                                          </Link>
//                                          <Link src="https://www.instagram.com/accounts/login/" style={styles.iconLink}>
//                                              <Image
//                                                  src="/images/instagramLogoBlue.png"
//                                                  style={styles.icon}
//                                                  alt="Instagram"
//                                              />
//                                          </Link>
//                                          <Link src="https://x.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJteCI6IjIifQ%3D%3D%22%7D" style={styles.iconLink}>
//                                              <Image
//                                                  src="/images/twitterLogoBlue.png"
//                                                  style={styles.icon}
//                                                  alt="Twitter"
//                                              />
//                                          </Link>
//                                          <Link src="https://discord.com/login" style={styles.iconLink}>
//                                              <Image
//                                                  src="/images/discordLogoBlue.png"
//                                                  style={styles.icon}
//                                                  alt="Discord"
//                                              />
//                                          </Link>
//                                      </View> */}
         
//                                      {/* <View style={styles.storeCopyrightContainer}>
//                                          <Text style={styles.lastpageCopyright}> */}
//                                              {/* © {new Date().getFullYear()} {vendor?.vendorDetails?.name}™. All Rights Reserved. Built with */}
//                                              {/* © 2021-2022 Fixlabs™. All Rights Reserved. Built with */}
//                                          {/* </Text>
//                                      </View> */}
         
//                                  {/* </View> */}
         
//                              {/* </View> */}
//                          {/* </View> */}
//                      </Page>
//         </Document >
//     )
// }

// export default StyleChronicles








import React, { useEffect, useState } from "react";
// import axios from "axios";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  // Font,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  frontPage: {
    backgroundColor: "#e5e6e8",
    position: "relative",
  },
  frontPageImageContainer: {
    width: "75%",
    height: "45%",
    position: "absolute",
    top: "-5%",
    right: "-10%",
    transform: "rotate(-45deg)",
    border: "5px solid white",
  },
  frontPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    position: "absolute",
    top: "0%",
    left: "0%",
  },
  frontPageLogoContainer: {
    width: "20%",
    height: "14%",
    position: "absolute",
    top: "10.5%",
    left: "10%",
    transform: "rotate(45deg)",
    backgroundColor: "#bd212f",
    // backgroundColor: '#3d2b17',
    justifyContent: "center", // Center the content
    alignItems: "center", // Center the content
  },
  frontPageLogoImage: {
    width: "80%",
    height: "auto",
    resizeMode: "contain",
    transform: "rotate(-45deg)",

    // height: '7.5%',
    // position: 'relative',
    // top: '13.7%',
    // left: '14.3%',
    // objectFit: 'cover',
  },
  frontPageBottomBox: {
    width: "130%",
    height: "100%",
    position: "absolute",
    bottom: "-40%",
    left: "-41.5%",
    transform: "rotate(45deg)",
    backgroundColor: "#bd212f",
    // backgroundColor: '#3d2b17',
    border: "5px solid white",
  },
  frontPageHeadingContainer: {
    position: "absolute",
    top: "55%",
    left: "10%",
    width: "70%",
    color: "white",
  },
  frontPageHeading: {
    fontSize: 50,
    fontWeight: "1000",
    marginTop: 15,
  },
  frontPageSubheading: {
    fontSize: 25,
    fontWeight: "bold",
  },
  frontPageDescription: {
    fontSize: 15,
    marginTop: 40,
  },
  frontPageYearContainer: {
    position: "absolute",
    bottom: "5%",
    right: "5%",
    color: "white",
    fontSize: 15,
  },
  // For tableofcontent page ==>>
  page: {
    // backgroundColor: '#e5e6e8',
    // position: 'relative',
  },
  tableofcontentPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    height: "100%",
  },
  tableofcontentPageFirstContainer: {
    height: "20%",
    width: "80%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  tableofcontentPageHeading: {
    fontSize: 40,
    fontWeight: "1000",
  },
  tableofcontentPageSubheading: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#bd212f",
  },
  tableofcontentPageDescription: {
    fontSize: 20,
  },
  tableofcontentPageSecondContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableofcontentPageThirdContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableofcontentPageFourthContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tableofcontentPageProductDetailsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    // paddingRight: '5%',
  },
  tableofcontentPageProductDetails: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "stretch",
    width: "80%",
    height: "100%",
  },
  tableofcontentPageProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
    color: "#bd212f",
  },
  tableofcontentPageProductDescription: {
    fontSize: 10,
  },
  tableofcontentPageProductPrice: {
    fontSize: 12.5,
    color: "#bd212f",
  },
  tableofcontentPageImageContainer: {
    width: "40%",
    height: "100%",
  },
  tableofcontentPageImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  tableofcontentVerticalLine: {
    width: 1,
    height: "80%",
    backgroundColor: "grey",
  },

  // For third page ==>>

  thirdPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    height: "100%",
  },
  thirdPageFirstContainer: {
    height: "20%",
    width: "80%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  thirdPageHeading: {
    fontSize: 40,
    fontWeight: "1000",
    color: "#bd212f",
  },
  thirdPageSubheading: {
    fontSize: 25,
    fontWeight: "bold",
  },
  thirdPageDescription: {
    fontSize: 20,
  },
  thirdPageSecondContainer: {
    backgroundColor: "#bd212f",
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  thirdPageThirdContainer: {
    backgroundColor: "#bd212f",
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  thirdPageFourthContainer: {
    backgroundColor: "#bd212f",
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  thirdPageProductDetailsContainer: {
    color: "white",
    display: "flex",
    justifyContent: "space-evenly",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
  },
  thirdPageProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },
  thirdPageProductDescription: {
    fontSize: 10,
  },
  thirdPageProductPrice: {
    fontSize: 12.5,
  },
  thirdPageImageContainer: {
    width: "40%",
    height: "100%",
  },
  thirdPageImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },

  // For fourth page ==>>

  fourthPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    height: "100%",
  },
  fourthPageFirstContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fourthPageSecondContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fourthPageThirdContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fourthPageFourthContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fourthPageProductDetailsContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
  },
  fourthPageProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
    color: "#bd212f",
  },
  fourthPageProductDescription: {
    fontSize: 10,
  },
  fourthPageProductPrice: {
    fontSize: 12.5,
    color: "#bd212f",
  },
  fourthPageImageContainer: {
    width: "40%",
    height: "100%",
  },
  fourthPageImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },

  // For fifth page ==>>

  fifthPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
  fifthPageFirstContainer: {
    width: "100%",
    height: "40%",
    padding: "10%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  fifthPageFirstUpperContainer: {
    height: "20%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  fifthPageSubheading: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#bd212f",
  },
  fifthPageHeading: {
    fontSize: 30,
    fontWeight: "1000",
    marginTop: 10,
  },
  fifthPageFirstLowerContainer: {
    backgroundColor: "#bd212f",
    height: "60%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fifthPageFirstLowerContainerProductDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "flex-start",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
    color: "white",
  },

  fifthPageFirstLowerContainerProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
    textAlign: "left",
  },
  fifthPageFirstLowerContainerProductDescription: {
    fontSize: 10,
    textAlign: "left",
  },
  fifthPageFirstLowerContainerProductPrice: {
    fontSize: 12.5,
    // color: '#bd212f',
    textAlign: "left",
  },
  fifthPageImageContainer: {
    width: "40%",
    height: "100%",
  },
  fifthPageImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  fifthPageSecondContainer: {
    width: "100%",
    height: "60%",
    padding: "10%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#bd212f",
    color: "white",
  },
  fifthPageSecondLeftContainer: {
    width: "39%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fifthPageSecondLeftContainerProductDetailsContainer: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "flex-start",
  },
  fifthPageSecondLeftContainerProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },
  fifthPageSecondLeftContainerProductDescription: {
    fontSize: 10,
  },
  fifthPageSecondLeftContainerProductPrice: {
    fontSize: 12.5,
  },
  fifthPageSecondLeftContainerImageContainer: {
    width: "100%",
    height: "40%",
  },
  fifthPageSecondLeftContainerImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  fifthPageVerticalLine: {
    width: 1,
    height: "100%",
    backgroundColor: "white",
  },
  fifthPageSecondRightContainer: {
    width: "39%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  fifthPageSecondRightContainerProductDetailsContainer: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "flex-start",
  },
  fifthPageSecondRightContainerProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },
  fifthPageSecondRightContainerProductDescription: {
    fontSize: 10,
  },
  fifthPageSecondRightContainerProductPrice: {
    fontSize: 12.5,
  },
  fifthPageSecondRightContainerImageContainer: {
    width: "100%",
    height: "40%",
  },
  fifthPageSecondRightContainerImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },

  // For sixth page ==>>

  sixthPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
  sixthPageFirstContainer: {
    width: "100%",
    height: "40%",
    padding: "10%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  sixthPageFirstUpperContainer: {
    height: "20%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  sixthPageSubheading: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#bd212f",
  },
  sixthPageHeading: {
    fontSize: 30,
    fontWeight: "1000",
    marginTop: 10,
  },
  sixthPageFirstLowerContainer: {
    backgroundColor: "#bd212f",
    height: "60%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sixthPageFirstLowerContainerProductDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "flex-start",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
    color: "white",
  },

  sixthPageFirstLowerContainerProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
    textAlign: "left",
  },
  sixthPageFirstLowerContainerProductDescription: {
    fontSize: 10,
    textAlign: "left",
  },
  sixthPageFirstLowerContainerProductPrice: {
    fontSize: 12.5,
    // color: '#bd212f',
    textAlign: "left",
  },
  sixthPageImageContainer: {
    width: "40%",
    height: "100%",
  },
  sixthPageImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  sixthPageSecondContainer: {
    width: "100%",
    height: "60%",
    padding: "10%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#bd212f",
    color: "white",
  },
  sixthPageSecondLeftContainer: {
    width: "39%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sixthPageSecondLeftContainerProductDetailsContainer: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "flex-start",
  },
  sixthPageSecondLeftContainerProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },
  sixthPageSecondLeftContainerProductDescription: {
    fontSize: 10,
  },
  sixthPageSecondLeftContainerProductPrice: {
    fontSize: 12.5,
  },
  sixthPageSecondLeftContainerImageContainer: {
    width: "100%",
    height: "40%",
  },
  sixthPageSecondLeftContainerImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  sixthPageVerticalLine: {
    width: 1,
    height: "100%",
    backgroundColor: "white",
  },
  sixthPageSecondRightContainer: {
    width: "39%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  sixthPageSecondRightContainerProductDetailsContainer: {
    width: "100%",
    height: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "flex-start",
  },
  sixthPageSecondRightContainerProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },
  sixthPageSecondRightContainerProductDescription: {
    fontSize: 10,
  },
  sixthPageSecondRightContainerProductPrice: {
    fontSize: 12.5,
  },
  sixthPageSecondRightContainerImageContainer: {
    width: "100%",
    height: "40%",
  },
  sixthPageSecondRightContainerImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },

  // For seventh page ==>>

  seventhPage: {
    position: "relative",
  },
  seventhPageBorderContainer: {
    margin: "5% 0% 5% 5%",
    padding: "5%",
    borderTop: "20px solid #bd212f",
    borderLeft: "20px solid #bd212f",
    borderBottom: "20px solid #bd212f",
    height: "95%",
  },
  seventhPageFirstContainer: {
    height: "30%",
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  seventhPageHeading: {
    fontSize: 40,
    fontWeight: "1000",
    color: "#bd212f",
  },
  seventhPageTitleHeading: {
    fontSize: 20,
    fontWeight: "1000",
    color: "#bd212f",
  },
  seventhPageSubheading: {
    fontSize: 25,
    fontWeight: "bold",
  },
  seventhPageDescription: {
    fontSize: 20,
  },
  seventhPageSecondContainer: {
    height: "50%",
    width: "100%",
  },
  seventhPageImageBackgroundContainer: {
    width: "80%",
    height: "90%",
    position: "absolute",
    bottom: 0,
    right: 0,
    border: "5px solid #bd212f",
  },
  seventhPageImage: {
    position: "relative",
    top: 70,
    left: 0,
    width: "70%",
    height: "70%",
    objectFit: "cover",
  },
  seventhPageThirdContainer: {
    height: "20%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // For eight page ==>>

  eightPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "95%",
    backgroundColor: "#bd212f",
    margin: "5% 5% 5% 0%",
  },
  eightPageFirstContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
  },
  eightPageSecondContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
  },
  eightPageThirdContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
  },
  eightPageFourthContainer: {
    // backgroundColor: '#bd212f',
    height: "20%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
  },
  eightPageProductDetailsContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
  },
  eightPageProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },
  eightPageProductDescription: {
    fontSize: 10,
  },
  eightPageProductPrice: {
    fontSize: 12.5,
  },
  eightPageImageContainer: {
    width: "40%",
    height: "100%",
  },
  eightPageImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },

  // For ninth page ==>>
  ninthPage: {
    position: "relative",
    padding: "10%",
  },

  ninthPageFirstContainer: {
    height: "30%",
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  ninthPageHeading: {
    fontSize: 40,
    fontWeight: "1000",
    color: "#bd212f",
  },
  ninthPageSubheading: {
    fontSize: 25,
    fontWeight: "bold",
  },
  ninthPageDescription: {
    fontSize: 20,
  },
  ninthPageSecondContainer: {
    height: "50%",
    width: "100%",
  },
  ninthPageImageFrontContainer: {
    width: "60%",
    height: "40%",
    position: "absolute",
    top: 0,
    left: 0,
    // backgroundColor: '#bd212f',
    backgroundColor: "#86161b",
    marginLeft: "5%",
  },
  ninthPageProductDetailsContainer: {
    display: "flex",
    justifyContent: "space-around",
    width: "90%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
    color: "white",
  },
  ninthPageProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },
  ninthPageProductDescription: {
    fontSize: 10,
  },
  ninthPageProductPrice: {
    fontSize: 12.5,
  },
  ninthPageImage: {
    position: "relative",
    top: 0,
    left: 0,
    width: "100%",
    height: "90%",
    objectFit: "cover",
    paddingLeft: "5%",
    paddingRight: "5%",
  },
  ninthPageThirdContainer: {
    height: "20%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#bd212f",
    color: "white",
    paddingLeft: "10%",
    paddingRight: "10%",
  },
  ninthPageThirdContainerDescription: {
    fontSize: 15,
  },
  // For tenth page ==>>

  tenthPage: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
    // padding:'5%'
  },
  tenthPageUpperContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    height: "50%",
    width: "100%",
  },
  tenthPageFirstContainer: {
    // backgroundColor: '#bd212f',
    height: "40%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tenthPageSecondContainer: {
    // backgroundColor: '#bd212f',
    height: "40%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tenthPageLowerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    height: "50%",
    width: "100%",
    backgroundColor: "#bd212f",
    color: "white",
  },
  tenthPageThirdContainer: {
    // backgroundColor: '#bd212f',
    height: "40%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tenthPageFourthContainer: {
    // backgroundColor: '#bd212f',
    height: "40%",
    width: "80%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tenthPageProductDetailsContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
  },
  tenthPageProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
    color: "#bd212f",
  },
  tenthPageProductDescription: {
    fontSize: 10,
  },
  tenthPageProductPrice: {
    fontSize: 12.5,
    color: "#bd212f",
  },
  tenthPageImageContainer: {
    width: "40%",
    height: "100%",
  },
  tenthPageImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  tenthPageLowerContainerProductDetailsContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    width: "60%",
    height: "100%",
    paddingLeft: "5%",
    paddingRight: "5%",
  },
  tenthPageLowerContainerProductTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
  },

  tenthPageLowerContainerProductPrice: {
    fontSize: 12.5,
  },
  tenthPageLowerContainerImageContainer: {
    width: "40%",
    height: "100%",
  },
  tenthPageLowerContainerImage: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },

  // For eleventh page ==>>
  eleventhPage: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  lastPageBackgroundFirstBox: {
    width: "15%",
    height: "10%",
    position: "absolute",
    top: "13%",
    left: "50%",
    transform: " rotate(45deg)",
    backgroundColor: "#bd212f",
  },
  lastPageBackgroundSecondBox: {
    width: "40%",
    height: "28%",
    position: "absolute",
    top: "15%",
    right: "-10%",
    transform: "rotate(45deg)",
    backgroundColor: "#e1e3e5",
  },
  lastPageLogoContainer: {
    width: "30%",
    height: "20%",
    position: "absolute",
    top: "30%",
    left: "35%",
    // transform: 'translate(-50%, -50%) rotate(45deg)',
    transform: "rotate(45deg)",
    backgroundColor: "#bd212f",
    justifyContent: "center", // Center the content
    alignItems: "center", // Center the content
  },
  lastPageLogoImage: {
    // position: 'relative',
    // top: '10%',
    // left: '10%',
    // transform: 'translate(-50%, -50%)',
    width: "80%",
    height: "auto",
    resizeMode: "contain", // Maintain aspect ratio and fit within the container
  },
  lastPageBottomContainer: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    height: "35%",
    backgroundColor: "#bd212f",
    padding: "10% 20%",
    display: "flex",
    // flexDirection: 'row',
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    color: "white",
  },
  // lastPageBottomLeftContainer: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //     justifyContent: 'space-evenly',
  //     alignItems: 'flex-start',
  //     height: '100%',
  //     width: '50%',
  // },
  // lastPageBottomRightContainer: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //     justifyContent: 'space-evenly',
  //     alignItems: 'flex-start',
  //     height: '100%',
  //     width: '50%',
  // },
  socialMediaIconContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "100%",
    width: "100%",
    color: "white",
    textDecoration: "none",
  },
  socialMediaIcon: {
    width: 40,
    height: 40,
    color: "white",
    objectFit: "cover",
  },
  socialMediaIconName: {
    fontSize: 15,
    fontWeight: "bold",
    color: "white",
  },
  lastPageManagerDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    fontSize: 15,
    textAlign: "center",
  },
  lastPageStoreNameAndNumberContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    fontSize: 15,
    textAlign: "center",
    color: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  lastPageStoreDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    fontSize: 15,
  },
  lastpageCopyright: {
    margin: "auto",
    fontSize: 10,
  },
});

const truncateText = (text, maxLength) => {
  if (!text) {
    return ""; // Return an empty string if the text is undefined or null
  }
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};

function StyleChronicles({ jsonData, vendor }) {
  const [Data, setData] = useState();

  useEffect(() => {
    setData(jsonData);
  }, [jsonData]);

  // const [products, setProducts] = useState([]);

  // useEffect(() => {
  //     axios.get('https://fakestoreapi.com/products')
  //         .then(response => {
  //             setProducts(response.data);
  //         })
  //         .catch(error => {
  //             console.error('Error fetching data: ', error);
  //         });
  // }, []);

  const getCurrentMonthAndYear = () => {
    const date = new Date();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const currentMonth = monthNames[date.getMonth()];
    const currentYear = date.getFullYear();
    return `${currentMonth} - ${currentYear}`;
  };

  console.log("This is the data of StyleChronicles :=>", Data);
  console.log(
    "IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
    Data?.Product?.[0]?.image
  );
  return (
    <Document>
      {/* First page ==>> */}
      <Page size="A4" style={styles.frontPage}>
        <View style={styles.frontPageImageContainer}>
          <Image
            style={styles.frontPageImage}
            src="/image/frontPageImage.jpg"
          />
        </View>
        <View style={styles.frontPageLogoContainer}>
          <Image style={styles.frontPageLogoImage} src="/blackberrysLogo.png" />
        </View>
        <View style={styles.frontPageBottomBox} />
        <View style={styles.frontPageHeadingContainer}>
          <Text style={styles.frontPageSubheading}>
            {Data?.Store?.storename}
          </Text>
          <Text style={styles.frontPageHeading}>PRODUCT{"\n"}CATALOG</Text>
          <Text style={styles.frontPageDescription}>
            Experience the perfect blend of quality and style with our
            thoughtfully crafted products.
          </Text>
        </View>
        <View style={styles.frontPageYearContainer}>
          <Text style={styles.frontPageYear}>{getCurrentMonthAndYear()}</Text>
        </View>
      </Page>

      {Data?.Product?.length === 1 ? (
        <Page size="A4">
          <View style={styles.seventhPage}>
            <View style={styles.seventhPageBorderContainer}>
              <View style={styles.seventhPageFirstContainer}>
                {/* <Text style={styles.seventhPageSubheading}>Try Now!</Text> */}
                <Text style={styles.seventhPageHeading}>
                  Trending Collections
                </Text>
                <Text style={styles.seventhPageTitleHeading}>
                  {Data?.Product?.[0]?.title}
                </Text>
                <Text style={styles.seventhPageDescription}>
                  {Data?.Product?.[0]?.price} Rs.
                </Text>
              </View>
              <View style={styles.seventhPageSecondContainer}>
                <View style={styles.seventhPageImageBackgroundContainer}></View>
                <Image
                  style={styles.seventhPageImage}
                  src={
                    Data?.Product?.[0]?.image &&
                    Data?.Product?.[0]?.image !== "N/A"
                      ? Data?.Product?.[0]?.image
                      : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
                  }
                />
              </View>
              <View style={styles.seventhPageThirdContainer}>
                <Text style={styles.seventhPageDescription}>
                  {Data?.Product?.[0]?.description
                    ? Data?.Product?.[0]?.description
                    : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                </Text>
              </View>
            </View>
          </View>
        </Page>
      ) : (
        <>
          {/* seventh page ==>> */}
          {Data?.Product?.length <= 2 && (
            <>
              <Page size="A4">
                <View style={styles.seventhPage}>
                  <View style={styles.seventhPageBorderContainer}>
                    <View style={styles.seventhPageFirstContainer}>
                      {/* <Text style={styles.seventhPageSubheading}>Try Now!</Text> */}
                      <Text style={styles.seventhPageHeading}>
                        Trending Collections
                      </Text>
                      <Text style={styles.seventhPageTitleHeading}>
                        {Data?.Product?.[0]?.title}
                      </Text>
                      <Text style={styles.seventhPageDescription}>
                        {Data?.Product?.[0]?.price} Rs.
                      </Text>
                    </View>
                    <View style={styles.seventhPageSecondContainer}>
                      <View
                        style={styles.seventhPageImageBackgroundContainer}
                      ></View>
                      <Image
                        style={styles.seventhPageImage}
                        src={
                          Data?.Product?.[0]?.image &&
                          Data?.Product?.[0]?.image !== "N/A"
                            ? Data?.Product?.[0]?.image
                            : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
                        }
                      />
                    </View>
                    <View style={styles.seventhPageThirdContainer}>
                      <Text style={styles.seventhPageDescription}>
                        {Data?.Product?.[0]?.description
                          ? Data?.Product?.[0]?.description
                          : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                      </Text>
                    </View>
                  </View>
                </View>
              </Page>

              <Page size="A4">
                <View style={styles.ninthPage}>
                  <View style={styles.ninthPageFirstContainer}>
                    {/* <Text style={styles.ninthPageSubheading}>Try Now!</Text> */}
                    <Text style={styles.ninthPageHeading}>
                      Trending Collections
                    </Text>
                    <Text style={styles.ninthPageDescription}>
                      {Data?.Product?.[1]?.price} Rs.
                    </Text>
                  </View>
                  <View style={styles.ninthPageSecondContainer}>
                    <Image
                      style={styles.ninthPageImage}
                      src={
                        Data?.Product?.[1]?.image &&
                        Data?.Product?.[1]?.image !== "N/A"
                          ? Data?.Product?.[1]?.image
                          : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
                      }
                    />
                    <View style={styles.ninthPageImageFrontContainer}>
                      <View style={styles.ninthPageProductDetailsContainer}>
                        <Text style={styles.ninthPageProductTitle}>
                          {Data?.Product?.[1]?.title}
                        </Text>
                        {/* <Text style={styles.ninthPageProductDescription}>{truncateText(products[17]?.description, 100)}</Text>
                                                <Text style={styles.ninthPageProductPrice}>{products[17]?.price}</Text> */}
                      </View>
                    </View>
                  </View>
                  <View style={styles.ninthPageThirdContainer}>
                    <Text style={styles.ninthPageThirdContainerDescription}>
                      {Data?.Product?.[1]?.description
                        ? Data?.Product?.[1]?.description
                        : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                    </Text>
                  </View>
                </View>
              </Page>
            </>
          )}

          {/* ninth page ==>> */}
          {/* {Data?.Product?.length <= 2 &&
                        <Page size="A4">
                            <View style={styles.ninthPage}>
                                <View style={styles.ninthPageFirstContainer}>
                                    <Text style={styles.ninthPageHeading}>Trending Collections</Text>
                                    <Text style={styles.ninthPageDescription}>
                                        {Data?.Product?.[1]?.price} Rs.
                                    </Text>
                                </View>
                                <View style={styles.ninthPageSecondContainer}>
                                    <Image style={styles.ninthPageImage} src={
            Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
                ? Data?.Product?.[1]?.image
                : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
        } />
                                    <View style={styles.ninthPageImageFrontContainer}>
                                        <View style={styles.ninthPageProductDetailsContainer}>
                                            <Text style={styles.ninthPageProductTitle}>{Data?.Product?.[1]?.title}</Text>
                                        </View>
                                    </View>
                                </View>
                                <View style={styles.ninthPageThirdContainer}>
                                    <Text style={styles.ninthPageThirdContainerDescription}>
                                        {Data?.Product?.[1]?.description ? Data?.Product?.[1]?.description : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                                    </Text>
                                </View>
                            </View>
                        </Page>
                    } */}

          {/* seventh page ==>> */}
          {Data?.Product?.length === 4 && (
            <Page size="A4">
              <View style={styles.seventhPage}>
                <View style={styles.seventhPageBorderContainer}>
                  <View style={styles.seventhPageFirstContainer}>
                    {/* <Text style={styles.seventhPageSubheading}>Try Now!</Text> */}
                    <Text style={styles.seventhPageHeading}>
                      Trending Collections
                    </Text>
                    <Text style={styles.seventhPageTitleHeading}>
                      {Data?.Product?.[3]?.title}
                    </Text>
                    <Text style={styles.seventhPageDescription}>
                      {Data?.Product?.[3]?.price} Rs.
                    </Text>
                  </View>
                  <View style={styles.seventhPageSecondContainer}>
                    <View
                      style={styles.seventhPageImageBackgroundContainer}
                    ></View>
                    <Image
                      style={styles.seventhPageImage}
                      src={
                        Data?.Product?.[3]?.image &&
                        Data?.Product?.[3]?.image !== "N/A"
                          ? Data?.Product?.[3]?.image
                          : Data?.Product?.[3]?.productImage // Fallback to Data?.Product?.[3]?.productImage
                      }
                    />
                  </View>
                  <View style={styles.seventhPageThirdContainer}>
                    <Text style={styles.seventhPageDescription}>
                      {Data?.Product?.[3]?.description
                        ? Data?.Product?.[3]?.description
                        : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                    </Text>
                  </View>
                </View>
              </View>
            </Page>
          )}

          {/* Fifth page ==>> */}
          {Data?.Product?.length >= 3 && (
            <Page size="A4" style={styles.page}>
              <View style={styles.fifthPage}>
                <View style={styles.fifthPageFirstContainer}>
                  <View style={styles.fifthPageFirstUpperContainer}>
                    <Text style={styles.fifthPageSubheading}>Try Now!</Text>
                    <Text style={styles.fifthPageHeading}>
                      Trending Collections
                    </Text>
                  </View>
                  <View style={styles.fifthPageFirstLowerContainer}>
                    <View
                      style={
                        styles.fifthPageFirstLowerContainerProductDetailsContainer
                      }
                    >
                      <Text
                        style={styles.fifthPageFirstLowerContainerProductTitle}
                      >
                        {Data?.Product?.[0]?.title}
                      </Text>
                      <Text
                        style={
                          styles.fifthPageFirstLowerContainerProductDescription
                        }
                      >
                        {truncateText(
                          Data?.Product?.[0]?.description
                            ? Data?.Product?.[0]?.description
                            : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                          100
                        )}
                      </Text>
                      <Text
                        style={styles.fifthPageFirstLowerContainerProductPrice}
                      >
                        {Data?.Product?.[0]?.price}
                      </Text>
                    </View>
                    <View style={styles.fifthPageImageContainer}>
                      <Image
                        style={styles.fifthPageImage}
                        src={
                          Data?.Product?.[0]?.image &&
                          Data?.Product?.[0]?.image !== "N/A"
                            ? Data?.Product?.[0]?.image
                            : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
                        }
                      />
                    </View>
                  </View>
                </View>
                <View style={styles.fifthPageSecondContainer}>
                  <View style={styles.fifthPageSecondLeftContainer}>
                    <View
                      style={
                        styles.fifthPageSecondLeftContainerProductDetailsContainer
                      }
                    >
                      <Text
                        style={styles.fifthPageSecondLeftContainerProductTitle}
                      >
                        {Data?.Product?.[1]?.title}
                      </Text>
                      <Text
                        style={
                          styles.fifthPageSecondLeftContainerProductDescription
                        }
                      >
                        {truncateText(
                          Data?.Product?.[1]?.description
                            ? Data?.Product?.[1]?.description
                            : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                          100
                        )}
                      </Text>
                      <Text
                        style={styles.fifthPageSecondLeftContainerProductPrice}
                      >
                        {Data?.Product?.[1]?.price}
                      </Text>
                    </View>
                    <View
                      style={styles.fifthPageSecondLeftContainerImageContainer}
                    >
                      <Image
                        style={styles.fifthPageSecondLeftContainerImage}
                        src={
                          Data?.Product?.[1]?.image &&
                          Data?.Product?.[1]?.image !== "N/A"
                            ? Data?.Product?.[1]?.image
                            : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
                        }
                      />
                    </View>
                  </View>
                  <View style={styles.fifthPageVerticalLine} />
                  <View style={styles.fifthPageSecondRightContainer}>
                    <View
                      style={
                        styles.fifthPageSecondRightContainerProductDetailsContainer
                      }
                    >
                      <Text
                        style={styles.fifthPageSecondRightContainerProductTitle}
                      >
                        {Data?.Product?.[2]?.title}
                      </Text>
                      <Text
                        style={
                          styles.fifthPageSecondRightContainerProductDescription
                        }
                      >
                        {truncateText(
                          Data?.Product?.[2]?.description
                            ? Data?.Product?.[2]?.description
                            : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                          100
                        )}
                      </Text>
                      <Text
                        style={styles.fifthPageSecondRightContainerProductPrice}
                      >
                        {Data?.Product?.[2]?.price}
                      </Text>
                    </View>
                    <View
                      style={styles.fifthPageSecondRightContainerImageContainer}
                    >
                      <Image
                        style={styles.fifthPageSecondRightContainerImage}
                        src={
                          Data?.Product?.[2]?.image &&
                          Data?.Product?.[2]?.image !== "N/A"
                            ? Data?.Product?.[2]?.image
                            : Data?.Product?.[2]?.productImage // Fallback to Data?.Product?.[2]?.productImage
                        }
                      />
                    </View>
                  </View>
                </View>
              </View>
            </Page>
          )}

          {/* Third page ==>> */}
          {Data?.Product?.length > 4 && (
            <Page size="A4">
              <View style={styles.thirdPage}>
                <View style={styles.thirdPageFirstContainer}>
                  <Text style={styles.thirdPageSubheading}>Try Now!</Text>
                  <Text style={styles.thirdPageHeading}>
                    Trending Collections
                  </Text>
                  <Text style={styles.thirdPageDescription}>
                    Experience the perfect blend of quality and style with our
                    thoughtfully crafted products.
                  </Text>
                </View>

                <View style={styles.thirdPageSecondContainer}>
                  <View style={styles.thirdPageProductDetailsContainer}>
                    <Text style={styles.thirdPageProductTitle}>
                      {Data?.Product?.[3]?.title}
                    </Text>
                    <Text style={styles.thirdPageProductDescription}>
                      {truncateText(
                        Data?.Product?.[3]?.description
                          ? Data?.Product?.[3]?.description
                          : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                        100
                      )}
                    </Text>
                    <Text style={styles.thirdPageProductPrice}>
                      {Data?.Product?.[3]?.price} Rs.
                    </Text>
                  </View>
                  <View style={styles.thirdPageImageContainer}>
                    <Image
                      style={styles.thirdPageImage}
                      src={
                        Data?.Product?.[3]?.image &&
                        Data?.Product?.[3]?.image !== "N/A"
                          ? Data?.Product?.[3]?.image
                          : Data?.Product?.[3]?.productImage // Fallback to Data?.Product?.[3]?.productImage
                      }
                    />
                  </View>
                </View>
                <View style={styles.thirdPageThirdContainer}>
                  <View style={styles.thirdPageProductDetailsContainer}>
                    <Text style={styles.thirdPageProductTitle}>
                      {Data?.Product?.[4]?.title}
                    </Text>
                    <Text style={styles.thirdPageProductDescription}>
                      {truncateText(
                        Data?.Product?.[4]?.description
                          ? Data?.Product?.[4]?.description
                          : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                        100
                      )}
                    </Text>
                    <Text style={styles.thirdPageProductPrice}>
                      {Data?.Product?.[4]?.price} Rs.
                    </Text>
                  </View>
                  <View style={styles.thirdPageImageContainer}>
                    <Image
                      style={styles.thirdPageImage}
                      src={
                        Data?.Product?.[4]?.image &&
                        Data?.Product?.[4]?.image !== "N/A"
                          ? Data?.Product?.[4]?.image
                          : Data?.Product?.[4]?.productImage // Fallback to Data?.Product?.[4]?.productImage
                      }
                    />
                  </View>
                </View>
                {Data?.Product?.length > 5 && (
                  <View style={styles.thirdPageFourthContainer}>
                    <View style={styles.thirdPageImageContainer}>
                      <Image
                        style={styles.thirdPageImage}
                        src={
                          Data?.Product?.[5]?.image &&
                          Data?.Product?.[5]?.image !== "N/A"
                            ? Data?.Product?.[5]?.image
                            : Data?.Product?.[5]?.productImage // Fallback to Data?.Product?.[5]?.productImage
                        }
                      />
                    </View>
                    <View style={styles.thirdPageProductDetailsContainer}>
                      <Text style={styles.thirdPageProductTitle}>
                        {Data?.Product?.[5]?.title}
                      </Text>
                      <Text style={styles.thirdPageProductDescription}>
                        {truncateText(
                          Data?.Product?.[5]?.description
                            ? Data?.Product?.[5]?.description
                            : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                          100
                        )}
                      </Text>
                      <Text style={styles.thirdPageProductPrice}>
                        {Data?.Product?.[5]?.price}
                      </Text>
                    </View>
                  </View>
                )}
              </View>
            </Page>
          )}

          {/* ninth page ==>> */}
          {Data?.Product?.length === 7 && (
            <Page size="A4">
              <View style={styles.ninthPage}>
                <View style={styles.ninthPageFirstContainer}>
                  {/* <Text style={styles.ninthPageSubheading}>Try Now!</Text> */}
                  <Text style={styles.ninthPageHeading}>
                    Trending Collections
                  </Text>
                  <Text style={styles.ninthPageDescription}>
                    {Data?.Product?.[6]?.price} Rs.
                  </Text>
                </View>
                <View style={styles.ninthPageSecondContainer}>
                  <Image
                    style={styles.ninthPageImage}
                    src={
                      Data?.Product?.[6]?.image &&
                      Data?.Product?.[6]?.image !== "N/A"
                        ? Data?.Product?.[6]?.image
                        : Data?.Product?.[6]?.productImage // Fallback to Data?.Product?.[6]?.productImage
                    }
                  />
                  <View style={styles.ninthPageImageFrontContainer}>
                    <View style={styles.ninthPageProductDetailsContainer}>
                      <Text style={styles.ninthPageProductTitle}>
                        {Data?.Product?.[6]?.title}
                      </Text>
                      {/* <Text style={styles.ninthPageProductDescription}>{truncateText(products[17]?.description, 100)}</Text>
                                    <Text style={styles.ninthPageProductPrice}>{products[17]?.price}</Text> */}
                    </View>
                  </View>
                </View>
                <View style={styles.ninthPageThirdContainer}>
                  <Text style={styles.ninthPageThirdContainerDescription}>
                    {Data?.Product?.[6]?.description
                      ? Data?.Product?.[6]?.description
                      : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                  </Text>
                </View>
              </View>
            </Page>
          )}

          {/* eight page ==>> */}
          {Data?.Product?.length > 7 && (
            <Page size="A4" style={styles.page}>
              <View style={styles.eightPage}>
                <View style={styles.eightPageFirstContainer}>
                  <View style={styles.eightPageImageContainer}>
                    <Image
                      style={styles.eightPageImage}
                      src={
                        Data?.Product?.[6]?.image &&
                        Data?.Product?.[6]?.image !== "N/A"
                          ? Data?.Product?.[6]?.image
                          : Data?.Product?.[6]?.productImage // Fallback to Data?.Product?.[6]?.productImage
                      }
                    />
                  </View>
                  <View style={styles.eightPageProductDetailsContainer}>
                    <Text style={styles.eightPageProductTitle}>
                      {Data?.Product?.[6]?.title}
                    </Text>
                    <Text style={styles.eightPageProductDescription}>
                      {truncateText(
                        Data?.Product?.[6]?.description
                          ? Data?.Product?.[6]?.description
                          : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                        100
                      )}
                    </Text>
                    <Text style={styles.eightPageProductPrice}>
                      {Data?.Product?.[6]?.price}
                    </Text>
                  </View>
                </View>
                <View style={styles.eightPageSecondContainer}>
                  <View style={styles.eightPageImageContainer}>
                    <Image
                      style={styles.eightPageImage}
                      src={
                        Data?.Product?.[7]?.image &&
                        Data?.Product?.[7]?.image !== "N/A"
                          ? Data?.Product?.[7]?.image
                          : Data?.Product?.[7]?.productImage // Fallback to Data?.Product?.[7]?.productImage
                      }
                    />
                  </View>
                  <View style={styles.eightPageProductDetailsContainer}>
                    <Text style={styles.eightPageProductTitle}>
                      {Data?.Product?.[7]?.title}
                    </Text>
                    <Text style={styles.eightPageProductDescription}>
                      {truncateText(
                        Data?.Product?.[7]?.description
                          ? Data?.Product?.[7]?.description
                          : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                        100
                      )}
                    </Text>
                    <Text style={styles.eightPageProductPrice}>
                      {Data?.Product?.[7]?.price}
                    </Text>
                  </View>
                </View>
                {Data?.Product?.length > 8 && (
                  <View style={styles.eightPageThirdContainer}>
                    <View style={styles.eightPageImageContainer}>
                      <Image
                        style={styles.fourthPageImage}
                        src={
                          Data?.Product?.[8]?.image &&
                          Data?.Product?.[8]?.image !== "N/A"
                            ? Data?.Product?.[8]?.image
                            : Data?.Product?.[8]?.productImage // Fallback to Data?.Product?.[8]?.productImage
                        }
                      />
                    </View>
                    <View style={styles.eightPageProductDetailsContainer}>
                      <Text style={styles.eightPageProductTitle}>
                        {Data?.Product?.[8]?.title}
                      </Text>
                      <Text style={styles.eightPageProductDescription}>
                        {truncateText(
                          Data?.Product?.[8]?.description
                            ? Data?.Product?.[8]?.description
                            : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                          100
                        )}
                      </Text>
                      <Text style={styles.eightPageProductPrice}>
                        {Data?.Product?.[8]?.price}
                      </Text>
                    </View>
                  </View>
                )}
                {Data?.Product?.length === 10 && (
                  <View style={styles.eightPageFourthContainer}>
                    <View style={styles.eightPageImageContainer}>
                      <Image
                        style={styles.eightPageImage}
                        src={
                          Data?.Product?.[9]?.image &&
                          Data?.Product?.[9]?.image !== "N/A"
                            ? Data?.Product?.[9]?.image
                            : Data?.Product?.[9]?.productImage // Fallback to Data?.Product?.[9]?.productImage
                        }
                      />
                    </View>
                    <View style={styles.eightPageProductDetailsContainer}>
                      <Text style={styles.eightPageProductTitle}>
                        {Data?.Product?.[9]?.title}
                      </Text>
                      <Text style={styles.eightPageProductDescription}>
                        {truncateText(
                          Data?.Product?.[9]?.description
                            ? Data?.Product?.[9]?.description
                            : "Experience the perfect blend of quality and style with our thoughtfully crafted products.",
                          100
                        )}
                      </Text>
                      <Text style={styles.eightPageProductPrice}>
                        {Data?.Product?.[9]?.price}
                      </Text>
                    </View>
                  </View>
                )}
              </View>
            </Page>
          )}

          {Data?.Product?.length >= 11 &&
            Data.Product.map((product, index) =>
              index % 2 === 0 ? (
                // First Page Layout
                <Page size="A4" key={`page-even-${index}`}>
                  <View style={styles.seventhPage}>
                    <View style={styles.seventhPageBorderContainer}>
                      <View style={styles.seventhPageFirstContainer}>
                        <Text style={styles.seventhPageHeading}>
                          Trending Collections
                        </Text>
                        <Text style={styles.seventhPageTitleHeading}>
                          {product.title}
                        </Text>
                        <Text style={styles.seventhPageDescription}>
                          {product.price} Rs.
                        </Text>
                      </View>
                      <View style={styles.seventhPageSecondContainer}>
                        <View
                          style={styles.seventhPageImageBackgroundContainer}
                        ></View>
                        <Image
                          style={styles.seventhPageImage}
                          src={
                            product.image && product.image !== "N/A"
                              ? product.image
                              : product.productImage // Fallback to product.productImage
                          }
                        />
                      </View>
                      <View style={styles.seventhPageThirdContainer}>
                        <Text style={styles.seventhPageDescription}>
                          {product.description
                            ? product.description
                            : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                        </Text>
                      </View>
                    </View>
                  </View>
                </Page>
              ) : (
                // Second Page Layout
                <Page size="A4" key={`page-odd-${index}`}>
                  <View style={styles.ninthPage}>
                    <View style={styles.ninthPageFirstContainer}>
                      <Text style={styles.ninthPageHeading}>
                        Trending Collections
                      </Text>
                      <Text style={styles.ninthPageDescription}>
                        {product.price} Rs.
                      </Text>
                    </View>
                    <View style={styles.ninthPageSecondContainer}>
                      <Image
                        style={styles.ninthPageImage}
                        src={
                          product.image && product.image !== "N/A"
                            ? product.image
                            : product.productImage // Fallback to product.productImage
                        }
                      />
                      <View style={styles.ninthPageImageFrontContainer}>
                        <View style={styles.ninthPageProductDetailsContainer}>
                          <Text style={styles.ninthPageProductTitle}>
                            {product.title}
                          </Text>
                        </View>
                      </View>
                    </View>
                    <View style={styles.ninthPageThirdContainer}>
                      <Text style={styles.ninthPageThirdContainerDescription}>
                        {product.description
                          ? product.description
                          : "Experience the perfect blend of quality and style with our thoughtfully crafted products."}
                      </Text>
                    </View>
                  </View>
                </Page>
              )
            )}
        </>
      )}

      {/* Start from here */}

      {/* second page ==>> */}
      {/* <Page size="A4">
                <View style={styles.tableofcontentPage}>
                    <View style={styles.tableofcontentPageFirstContainer}>
                        <Text style={styles.tableofcontentPageSubheading}>Table of</Text>
                        <Text style={styles.tableofcontentPageHeading}>Content</Text>
                        <Text style={styles.tableofcontentPageDescription}>
                            Experience the perfect blend of quality and style with our thoughtfully crafted products.
                        </Text>
                    </View>
                    <View style={styles.tableofcontentPageSecondContainer}>
                        <View style={styles.tableofcontentPageImageContainer}>
                            <Image style={styles.tableofcontentPageImage} src={products[4]?.image} />
                        </View>
                        <View style={styles.tableofcontentPageProductDetailsContainer}>
                            <View style={styles.tableofcontentPageProductDetails}>
                                <Text style={styles.tableofcontentPageProductTitle}>{products[4]?.title}</Text>
                                <Text style={styles.tableofcontentPageProductDescription}>{products[4]?.description}</Text>
                                <Text style={styles.tableofcontentPageProductPrice}>{products[4]?.price}</Text>
                            </View>
                            <View style={styles.tableofcontentVerticalLine} />
                            <View>
                                <Text style={styles.tableofcontentPageProductTitle}>02</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableofcontentPageThirdContainer}>
                        <View style={styles.tableofcontentPageImageContainer}>
                            <Image style={styles.tableofcontentPageImage} src={products[5]?.image} />
                        </View>
                        <View style={styles.tableofcontentPageProductDetailsContainer}>
                            <View style={styles.tableofcontentPageProductDetails}>
                                <Text style={styles.tableofcontentPageProductTitle}>{products[5]?.title}</Text>
                                <Text style={styles.tableofcontentPageProductDescription}>{products[5]?.description}</Text>
                                <Text style={styles.tableofcontentPageProductPrice}>{products[5]?.price}</Text>
                            </View>
                            <View style={styles.tableofcontentVerticalLine} />
                            <View>
                                <Text style={styles.tableofcontentPageProductTitle}>04</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableofcontentPageFourthContainer}>
                        <View style={styles.tableofcontentPageImageContainer}>
                            <Image style={styles.tableofcontentPageImage} src={products[6]?.image} />
                        </View>
                        <View style={styles.tableofcontentPageProductDetailsContainer}>
                            <View style={styles.tableofcontentPageProductDetails}>
                                <Text style={styles.tableofcontentPageProductTitle}>{products[6]?.title}</Text>
                                <Text style={styles.tableofcontentPageProductDescription}>{products[6]?.description}</Text>
                                <Text style={styles.tableofcontentPageProductPrice}>{products[6]?.price}</Text>
                            </View>
                            <View style={styles.tableofcontentVerticalLine} />
                            <View>
                                <Text style={styles.tableofcontentPageProductTitle}>08</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page> */}

      {/* Fourth page ==>> */}
      {/* <Page size="A4" style={styles.page}>
                <View style={styles.fourthPage}>
                    <View style={styles.fourthPageFirstContainer}>
                        <View style={styles.fourthPageImageContainer}>
                            <Image style={styles.fourthPageImage} src={products[3]?.image} />
                        </View>
                        <View style={styles.fourthPageProductDetailsContainer}>
                            <Text style={styles.fourthPageProductTitle}>{products[3]?.title}</Text>
                            <Text style={styles.fourthPageProductDescription}>{truncateText(products[3]?.description, 100)}</Text>
                            <Text style={styles.fourthPageProductPrice}>{products[3]?.price}</Text>
                        </View>
                    </View>
                    <View style={styles.fourthPageSecondContainer}>
                        <View style={styles.fourthPageImageContainer}>
                            <Image style={styles.fourthPageImage} src={products[4]?.image} />
                        </View>
                        <View style={styles.fourthPageProductDetailsContainer}>
                            <Text style={styles.fourthPageProductTitle}>{products[4]?.title}</Text>
                            <Text style={styles.fourthPageProductDescription}>{truncateText(products[4]?.description, 100)}</Text>
                            <Text style={styles.fourthPageProductPrice}>{products[4]?.price}</Text>
                        </View>
                    </View>
                    <View style={styles.fourthPageThirdContainer}>
                        <View style={styles.fourthPageImageContainer}>
                            <Image style={styles.fourthPageImage} src={products[5]?.image} />
                        </View>
                        <View style={styles.fourthPageProductDetailsContainer}>
                            <Text style={styles.fourthPageProductTitle}>{products[5]?.title}</Text>
                            <Text style={styles.fourthPageProductDescription}>{truncateText(products[5]?.description, 100)}</Text>
                            <Text style={styles.fourthPageProductPrice}>{products[5]?.price}</Text>
                        </View>
                    </View>
                    <View style={styles.fourthPageFourthContainer}>
                        <View style={styles.fourthPageImageContainer}>
                            <Image style={styles.fourthPageImage} src={products[6]?.image} />
                        </View>
                        <View style={styles.fourthPageProductDetailsContainer}>
                            <Text style={styles.fourthPageProductTitle}>{products[6]?.title}</Text>
                            <Text style={styles.fourthPageProductDescription}>{truncateText(products[6]?.description, 100)}</Text>
                            <Text style={styles.fourthPageProductPrice}>{products[6]?.price}</Text>
                        </View>
                    </View>
                </View>
            </Page> */}

      {/* sixth page ==>> */}
      {/* <Page size="A4" style={styles.page}>
                <View style={styles.sixthPage}>
                    <View style={styles.sixthPageFirstContainer}>
                        <View style={styles.sixthPageFirstUpperContainer}>
                            <Text style={styles.sixthPageSubheading}>Try Now!</Text>
                            <Text style={styles.sixthPageHeading}>Party Collections</Text>
                        </View>
                        <View style={styles.sixthPageFirstLowerContainer}>
                            <View style={styles.sixthPageImageContainer}>
                                <Image style={styles.sixthPageImage} src={products[10]?.image} />
                            </View>
                            <View style={styles.sixthPageFirstLowerContainerProductDetailsContainer}>
                                <Text style={styles.sixthPageFirstLowerContainerProductTitle}>{products[10]?.title}</Text>
                                <Text style={styles.sixthPageFirstLowerContainerProductDescription}>{truncateText(products[10]?.description, 100)}</Text>
                                <Text style={styles.sixthPageFirstLowerContainerProductPrice}>{products[10]?.price}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.sixthPageSecondContainer}>
                        <View style={styles.sixthPageSecondLeftContainer}>
                            <View style={styles.sixthPageSecondLeftContainerProductDetailsContainer}>
                                <Text style={styles.sixthPageSecondLeftContainerProductTitle}>{products[11]?.title}</Text>
                                <Text style={styles.sixthPageSecondLeftContainerProductDescription}>{truncateText(products[11]?.description, 100)}</Text>
                                <Text style={styles.sixthPageSecondLeftContainerProductPrice}>{products[11]?.price}</Text>
                            </View>
                            <View style={styles.sixthPageSecondLeftContainerImageContainer}>
                                <Image style={styles.sixthPageSecondLeftContainerImage} src={products[11]?.image} />
                            </View>
                        </View>
                        <View style={styles.sixthPageVerticalLine} />
                        <View style={styles.sixthPageSecondRightContainer}>
                            <View style={styles.sixthPageSecondRightContainerProductDetailsContainer}>
                                <Text style={styles.sixthPageSecondRightContainerProductTitle}>{products[12]?.title}</Text>
                                <Text style={styles.sixthPageSecondRightContainerProductDescription}>{truncateText(products[12]?.description, 100)}</Text>
                                <Text style={styles.sixthPageSecondRightContainerProductPrice}>{products[12]?.price}</Text>
                            </View>
                            <View style={styles.sixthPageSecondRightContainerImageContainer}>
                                <Image style={styles.sixthPageSecondRightContainerImage} src={products[12]?.image} />
                            </View>
                        </View>
                    </View>
                </View>
            </Page> */}

      {/* eight page ==>> */}
      {/* <Page size="A4" style={styles.page}>
                <View style={styles.eightPage}>
                    <View style={styles.eightPageFirstContainer}>
                        <View style={styles.eightPageImageContainer}>
                            <Image style={styles.eightPageImage} src={products[13]?.image} />
                        </View>
                        <View style={styles.eightPageProductDetailsContainer}>
                            <Text style={styles.eightPageProductTitle}>{products[13]?.title}</Text>
                            <Text style={styles.eightPageProductDescription}>{truncateText(products[13]?.description, 100)}</Text>
                            <Text style={styles.eightPageProductPrice}>{products[13]?.price}</Text>
                        </View>
                    </View>
                    <View style={styles.eightPageSecondContainer}>
                        <View style={styles.eightPageImageContainer}>
                            <Image style={styles.eightPageImage} src={products[14]?.image} />
                        </View>
                        <View style={styles.eightPageProductDetailsContainer}>
                            <Text style={styles.eightPageProductTitle}>{products[14]?.title}</Text>
                            <Text style={styles.eightPageProductDescription}>{truncateText(products[14]?.description, 100)}</Text>
                            <Text style={styles.eightPageProductPrice}>{products[14]?.price}</Text>
                        </View>
                    </View>
                    <View style={styles.eightPageThirdContainer}>
                        <View style={styles.eightPageImageContainer}>
                            <Image style={styles.fourthPageImage} src={products[15]?.image} />
                        </View>
                        <View style={styles.eightPageProductDetailsContainer}>
                            <Text style={styles.eightPageProductTitle}>{products[15]?.title}</Text>
                            <Text style={styles.eightPageProductDescription}>{truncateText(products[15]?.description, 100)}</Text>
                            <Text style={styles.eightPageProductPrice}>{products[15]?.price}</Text>
                        </View>
                    </View>
                    <View style={styles.eightPageFourthContainer}>
                        <View style={styles.eightPageImageContainer}>
                            <Image style={styles.eightPageImage} src={products[16]?.image} />
                        </View>
                        <View style={styles.eightPageProductDetailsContainer}>
                            <Text style={styles.eightPageProductTitle}>{products[16]?.title}</Text>
                            <Text style={styles.eightPageProductDescription}>{truncateText(products[16]?.description, 100)}</Text>
                            <Text style={styles.eightPageProductPrice}>{products[16]?.price}</Text>
                        </View>
                    </View>
                </View>
            </Page> */}

      {/* tenth page ==>> */}
      {/* <Page size="A4" style={styles.page}>
                <View style={styles.tenthPage}>
                    <View style={styles.tenthPageUpperContainer}>
                        <View style={styles.tenthPageFirstContainer}>
                            <View style={styles.tenthPageImageContainer}>
                                <Image style={styles.tenthPageImage} src={products[18]?.image} />
                            </View>
                            <View style={styles.tenthPageProductDetailsContainer}>
                                <Text style={styles.tenthPageProductTitle}>{products[18]?.title}</Text>
                                <Text style={styles.tenthPageProductDescription}>{truncateText(products[18]?.description, 100)}</Text>
                                <Text style={styles.tenthPageProductPrice}>{products[18]?.price}</Text>
                            </View>
                        </View>
                        <View style={styles.tenthPageSecondContainer}>
                            <View style={styles.tenthPageImageContainer}>
                                <Image style={styles.tenthPageImage} src={products[19]?.image} />
                            </View>
                            <View style={styles.tenthPageProductDetailsContainer}>
                                <Text style={styles.tenthPageProductTitle}>{products[19]?.title}</Text>
                                <Text style={styles.tenthPageProductDescription}>{truncateText(products[19]?.description, 100)}</Text>
                                <Text style={styles.tenthPageProductPrice}>{products[19]?.price}</Text>
                            </View>
                        </View>
                    </View>

                    <View style={styles.tenthPageLowerContainer}>
                        <View style={styles.tenthPageThirdContainer}>
                            <View style={styles.tenthPageLowerContainerImageContainer}>
                                <Image style={styles.tenthPageLowerContainerImage} src={products[12]?.image} />
                            </View>
                            <View style={styles.tenthPageProductDetailsContainer}>
                                <Text style={styles.tenthPageLowerContainerProductTitle}>{products[12]?.title}</Text>
                                <Text style={styles.tenthPageProductDescription}>{truncateText(products[12]?.description, 100)}</Text>
                                <Text style={styles.tenthPageLowerContainerProductPrice}>{products[12]?.price}</Text>
                            </View>
                        </View>
                        <View style={styles.tenthPageFourthContainer}>
                            <View style={styles.tenthPageLowerContainerImageContainer}>
                                <Image style={styles.tenthPageLowerContainerImage} src={products[8]?.image} />
                            </View>
                            <View style={styles.tenthPageLowerContainerProductDetailsContainer}>
                                <Text style={styles.tenthPageLowerContainerProductTitle}>{products[8]?.title}</Text>
                                <Text style={styles.tenthPageProductDescription}>{truncateText(products[8]?.description, 100)}</Text>
                                <Text style={styles.tenthPageLowerContainerProductPrice}>{products[8]?.price}</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page> */}

      {/* eleventh page ==>> */}
      <Page size="A4" style={styles.eleventhPage}>
        <View style={styles.lastPageBackgroundFirstBox} />
        <View style={styles.lastPageBackgroundSecondBox} />
        {/* <View style={styles.lastPageUpperContainer}> */}
        {/* <View style={styles.lastPageContentContainer}> */}
        <View style={styles.lastPageLogoContainer}>
          <Image
            style={styles.lastPageLogoImage}
            // src={(vendor?.vendorDetails?.logo?.url) ? vendor?.vendorDetails?.logo?.url : "/logo.png"}
            // src="https://storage.googleapis.com/fixlabsinficonnect/documents/20241206T122850788Z-1d8e1c615e90f989f299e273e3b7bcaa%20(1).png"
            src="/blackberrysLogo.png"
          />
        </View>

        <View style={styles.lastPageBottomContainer}>
          <View style={styles.lastPageStoreNameAndNumberContainer}>
            <Text style={styles.lastPageStoreNameContainer}>
              {Data?.Store?.storename}
            </Text>
            <Text style={styles.lastPageStorePhoneNumberContainer}>
              {Data?.Store?.storePhone}
            </Text>
          </View>
          {/* <View style={styles.lastPageManagerEmailContainer}>
                                         <Text style={styles.lastPageManagerName}>Pranjal.Sengar@gmail.com</Text>
                                     </View> */}
        </View>
        {/* <View style={styles.lastPageStoreDetailsContainer}> */}

        {/* <View style={styles.storeLocationContainer}>
                                         <Text style={styles.storeLocation}>{Data?.Store?.storeAddress}</Text>
                                     </View> */}

        {/* <View style={styles.socialLinks}>
                                         <Link src="https://www.facebook.com/login.php" style={styles.iconLink}>
                                             <Image
                                                 src="/images/facebookLogoBlue.png"
                                                 style={styles.icon}
                                                 alt="Facebook"
                                             />
                                         </Link>
                                         <Link src="https://www.instagram.com/accounts/login/" style={styles.iconLink}>
                                             <Image
                                                 src="/images/instagramLogoBlue.png"
                                                 style={styles.icon}
                                                 alt="Instagram"
                                             />
                                         </Link>
                                         <Link src="https://x.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJteCI6IjIifQ%3D%3D%22%7D" style={styles.iconLink}>
                                             <Image
                                                 src="/images/twitterLogoBlue.png"
                                                 style={styles.icon}
                                                 alt="Twitter"
                                             />
                                         </Link>
                                         <Link src="https://discord.com/login" style={styles.iconLink}>
                                             <Image
                                                 src="/images/discordLogoBlue.png"
                                                 style={styles.icon}
                                                 alt="Discord"
                                             />
                                         </Link>
                                     </View> */}

        {/* <View style={styles.storeCopyrightContainer}>
                                         <Text style={styles.lastpageCopyright}> */}
        {/* © {new Date().getFullYear()} {vendor?.vendorDetails?.name}™. All Rights Reserved. Built with */}
        {/* © 2021-2022 Fixlabs™. All Rights Reserved. Built with */}
        {/* </Text>
                                     </View> */}

        {/* </View> */}

        {/* </View> */}
        {/* </View> */}
      </Page>
    </Document>
  );
}

export default StyleChronicles;